import ReactDOM from "react-dom";
import styles from "./styles.module.css";

import SignatureCanvas from "react-signature-canvas";
import { Row, Col, Container } from "react-bootstrap";
import $ from "jquery";

import {
  saveGeneralAgreement,
  unsignedAgreements,
  saveChooseSignature,
  sendToSignee,
  prepareSigneeLink,
  downloadAgreementPdf,
} from "../../config/api_calls";
import { REPLACECONTENT, ValidateEmail, replaceAgreementPlaceholders } from "../../config/utility";
import { Component } from 'react';
import HelperClass from "./../../config/helperClass";
import MutextField from "@material-ui/core/TextField";
import NotificationToast from "../Notification/NotificationToast";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
// import parsePhoneNumberFromString from "libphonenumber-js";

import {
  THEME_COLOR,
  THEME_TEXT_COLOR,
  VENDOR_SIGNATURE,
  ADMIN_URL,
  APP_LIVE_URL,
} from "../../config/config";

import "./agreement.css";
import * as docx from "docx";

const auth = new HelperClass();
const {
  Document,
  Packer,
  Paragraph,
  TextRun,
  ImageRun,
  Table,
  TableRow,
  TableCell,
  WidthType,
  AlignmentType,
  BorderStyle,
  HeadingLevel,
  UnderlineType,
  convertInchesToTwip,
} = docx;

// Extracts <style> blocks from agreement HTML, prefixes every rule with a
// unique wrapper class, and returns the cleaned HTML + scoped CSS separately.
// This prevents one agreement's embedded styles from leaking into the page.
const scopeAgreementStyles = (html, scopeClass) => {
  let scopedCss = '';
  const scopedHtml = html.replace(/<style[\s\S]*?>([\s\S]*?)<\/style>/gi, (_match, cssContent) => {
    const cleaned = cssContent.replace(/\/\*[\s\S]*?\*\//g, '');
    const ruleRegex = /([^{]+)\{([^}]*)\}/g;
    let m;
    while ((m = ruleRegex.exec(cleaned)) !== null) {
      const selectors = m[1].trim();
      const declarations = m[2].trim();
      if (!selectors || !declarations) continue;
      const prefixed = selectors
        .split(',')
        .map(sel => {
          const s = sel.trim();
          if (!s) return '';
          if (s === 'body') return `.${scopeClass}`;
          if (s.startsWith('body ')) return `.${scopeClass} ${s.slice(5)}`;
          return `.${scopeClass} ${s}`;
        })
        .filter(Boolean)
        .join(', ');
      scopedCss += `${prefixed} { ${declarations} }\n`;
    }
    return '';
  });
  return { scopedHtml, scopedCss };
};

export default class Agreement extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: "",
      successMessage: "",
      errorMessageSignee: "",
      successMessageSignee: "",
      agreementData: [],
      replacable_content: "",
      final_content: "",
      agreement_id: "",
      agreement_title: "",
      signature_zero: 1,
      signature_one: 0,
      signature_two: 0,
      signature_three: 0,
      signature_four: 0,
      vendor_signature: "",
      agreement_type: "esign",
      is_checked: "",
      signatureText: localStorage.getItem(`lastTypedSignature_${auth.getAccount()}`) || (typeof auth.getName === "function" ? auth.getName() : "") || auth.getCompName() || "",
      signatureClass: localStorage.getItem(`lastSignatureClass_${auth.getAccount()}`) || "'Amita', cursive",
      signature_type: "draw",
      signee_name: "",
      signee_email: "",
      signee_title: "",
      signee_comment: "",
      charLimit: 1000,
      characterExceededMessage: "",
      signee_token: "",
      copied: false,
      preparedSigningUrl: "",
      copyLinkLoading: false,
      uploadedSignature: "",
      signatureDrawn: false,
      signatureColor: "#0F3A70",
      penWidth: 2,
      loadingButton: false,
      showSigneeForm: false,
      activeTabIndex: 0,
      toastMessage: "",
      toastType: "success",
      toastTitle: "",
      scrollProgress: 0,
      hasReachedEndOnce: false,
      consentChecked: false,
      currentStep: 1,
      readFullscreenOpen: false,
      highlightConsent: false,
      inlineAtBottom: false,
      fullscreenAtBottom: false,
      signatureModalOpen: false,
      modalCanvasEmpty: true,
      signatureDataUrl: "",
      drawPadKey: 0,
      downloading: false,
      downloadingFormat: "",
      ccList: [],
      ccOpen: false,
      resellerUserData: [],
      vendorData: [],
      signatoryData: [],
      agreement_accountno: "",
    };
    this.penSizes = [
      { label: "Fine", penWidth: 2, dotSize: 4 },
      { label: "Medium", penWidth: 3.5, dotSize: 6 },
      { label: "Bold", penWidth: 5.5, dotSize: 9 },
    ];
    this.inkColors = [
      { name: "Navy", value: "#0F3A70" },
      { name: "Black", value: "#111827" },
      { name: "Green", value: "#1A7A4A" },
    ];
    this.cursiveFonts = [
      { name: "Your Signature", value: "'Amita', cursive" },
      { name: "Your Signature", value: "'Bad Script', cursive" },
      { name: "Your Signature", value: "'Damion', cursive" },
      { name: "Your Signature", value: "'Dancing Script', cursive" },
      { name: "Your Signature", value: "'Felipa', cursive" },
      { name: "Your Signature", value: "'Julee', cursive" },
      { name: "Your Signature", value: "'Kaushan Script', cursive" },
      { name: "Your Signature", value: "'Lugrasimo', cursive" },
      { name: "Your Signature", value: "'Pacifico', cursive" },
      { name: "Your Signature", value: "'Sofia', cursive" },
      { name: "Your Signature", value: "'Yellowtail', cursive" },
      // Add more cursive fonts here
    ];
    this.inlineSignatureStrokes = [];
    this.modalSignatureStrokes = [];
  }

  cloneSignatureStrokes = (strokes = []) =>
    strokes.map((stroke) => stroke.map((point) => ({ ...point })));

  getSignatureStrokes = (pad) => {
    if (!pad || typeof pad.toData !== "function") {
      return [];
    }
    return this.cloneSignatureStrokes(pad.toData());
  };

  applySignatureStrokes = (pad, strokes = []) => {
    if (!pad) {
      return;
    }
    pad.clear();
    if (strokes.length > 0) {
      pad.fromData(this.cloneSignatureStrokes(strokes));
    }
  };

  // Properly resize canvas with device pixel ratio support
  resizeSignatureCanvas = (canvasRef, containerHeight = 120) => {
    if (!canvasRef || !canvasRef.canvas) return;

    const dpr = window.devicePixelRatio || 1;
    const canvas = canvasRef.canvas;
    const container = canvas.parentElement;

    if (!container) return;

    const rect = container.getBoundingClientRect();
    const width = rect.width;
    if (width <= 0) return;
    const height = containerHeight;
    
    // Set CSS size
    canvas.style.width = width + "px";
    canvas.style.height = height + "px";
    
    // Set actual canvas resolution with DPR
    canvas.width = Math.round(width * dpr);
    canvas.height = Math.round(height * dpr);
    
    // Scale context for DPR
    const ctx = canvas.getContext("2d");
    ctx.scale(dpr, dpr);
  };

  // Export signature with proper DPR downscaling to prevent zoom effect
  getScaledSignatureDataUrl = (canvasRef) => {
    if (!canvasRef || !canvasRef.canvas) return "";

    try {
      const trimmedCanvas = canvasRef.getTrimmedCanvas();
      if (!trimmedCanvas || !trimmedCanvas.width || !trimmedCanvas.height) {
        return "";
      }

      const dpr = window.devicePixelRatio || 1;
      if (dpr === 1) {
        return trimmedCanvas.toDataURL("image/png");
      }

      // For high DPR, create properly scaled export
      const scaledCanvas = document.createElement("canvas");
      const scaledCtx = scaledCanvas.getContext("2d");

      const targetWidth = Math.max(1, Math.round(trimmedCanvas.width / dpr));
      const targetHeight = Math.max(1, Math.round(trimmedCanvas.height / dpr));
      scaledCanvas.width = targetWidth;
      scaledCanvas.height = targetHeight;

      scaledCtx.drawImage(
        trimmedCanvas,
        0,
        0,
        trimmedCanvas.width,
        trimmedCanvas.height,
        0,
        0,
        targetWidth,
        targetHeight
      );

      return scaledCanvas.toDataURL("image/png");
    } catch (e) {
      return "";
    }
  };

  syncInlineSignatureState = () => {
    const hasSignature = this.inlineSignatureStrokes.length > 0;
    let signatureDataUrl = "";
    if (hasSignature && this.signaturePad) {
      signatureDataUrl = this.getScaledSignatureDataUrl(this.signaturePad);
      // Fallback: if the scaled export came back empty (e.g. a freshly remounted
      // canvas), use the raw trimmed canvas so we never end up flagged as
      // "drawn" while showing a blank box.
      if (!signatureDataUrl) {
        try {
          const trimmed = this.signaturePad.getTrimmedCanvas();
          if (trimmed && trimmed.width > 0 && trimmed.height > 0) {
            signatureDataUrl = trimmed.toDataURL("image/png");
          }
        } catch (e) {
          signatureDataUrl = "";
        }
      }
    }
    this.setState({ signatureDrawn: hasSignature && !!signatureDataUrl, signatureDataUrl }, () => {
      if (hasSignature && signatureDataUrl) {
        this.persistSignatureForCarryForward();
      }
    });
    this.updateSignaturePreviewInAgreement(signatureDataUrl);
  };

  handleInlineSignatureBegin = () => {
    if (this.state.signatureDataUrl) {
      this.inlineSignatureStrokes = [];
      this.setState({ signatureDataUrl: "" });
      this.updateSignaturePreviewInAgreement("");
    }
  };

  handleInlineSignatureEnd = () => {
    this.inlineSignatureStrokes = this.getSignatureStrokes(this.signaturePad);
    this.syncInlineSignatureState();
    if (this.signaturePad && !this.signaturePad.isEmpty()) {
      try {
        const trimmedCanvas = this.signaturePad.getTrimmedCanvas();
        if (trimmedCanvas && trimmedCanvas.width > 0 && trimmedCanvas.height > 0) {
          const dataUrl = trimmedCanvas.toDataURL("image/png");
          if (dataUrl) this.updateSignaturePreviewInAgreement(dataUrl);
        }
      } catch (e) {
        // Ignore invalid canvas state; preview stays in sync via syncInlineSignatureState()
      }
    }
  };

  handleModalSignatureBegin = () => {
    if (this.state.modalCanvasEmpty) {
      this.setState({ modalCanvasEmpty: false });
    }
  };

  handleModalSignatureEnd = () => {
    this.modalSignatureStrokes = this.getSignatureStrokes(this.signaturePadModal);
    this.setState({ modalCanvasEmpty: this.modalSignatureStrokes.length === 0 });
  };

  undoModalSignature = () => {
    if (!this.signaturePadModal) {
      return;
    }
    const currentStrokes = this.modalSignatureStrokes.length
      ? this.cloneSignatureStrokes(this.modalSignatureStrokes)
      : this.getSignatureStrokes(this.signaturePadModal);
    if (!currentStrokes.length) {
      this.setState({ modalCanvasEmpty: true });
      return;
    }
    currentStrokes.pop();
    this.modalSignatureStrokes = currentStrokes;
    this.applySignatureStrokes(this.signaturePadModal, currentStrokes);
    this.setState({ modalCanvasEmpty: currentStrokes.length === 0 });
  };

  clearModalSignature = () => {
    this.modalSignatureStrokes = [];
    if (this.signaturePadModal) {
      this.signaturePadModal.clear();
    }
    this.setState({ modalCanvasEmpty: true });
  };

  useModalSignature = () => {
    if (!this.signaturePadModal || this.signaturePadModal.isEmpty()) {
      return;
    }
    this.modalSignatureStrokes = this.getSignatureStrokes(this.signaturePadModal);
    this.inlineSignatureStrokes = [];
    if (this.signaturePad) {
      this.signaturePad.clear();
    }
    const signatureDataUrl =
      this.signaturePadModal.getTrimmedCanvas().toDataURL("image/svg+xml") ||
      this.getScaledSignatureDataUrl(this.signaturePadModal);
    this.setState({
      signatureModalOpen: false,
      signature_type: "draw",
      signatureDrawn: true,
      signatureDataUrl,
      modalCanvasEmpty: this.modalSignatureStrokes.length === 0,
    }, () => {
      this.updateSignaturePreviewInAgreement(signatureDataUrl);
      this.persistSignatureForCarryForward();
    });
  };

  // removeStored=false performs a soft clear (UI only) used when switching
  // signature tabs — the signature persisted in localStorage must survive so
  // the user can switch back to it. An explicit "Clear" keeps the default and
  // also drops the stored copy.
  clear = (removeStored = true) => {
    this.inlineSignatureStrokes = [];
    this.modalSignatureStrokes = [];
    if (this.signaturePad) {
      this.signaturePad.clear();
    }
    if (this.signaturePadModal) {
      this.signaturePadModal.clear();
    }
    this.setState({ signatureDrawn: false, modalCanvasEmpty: true, signatureDataUrl: "" });
    $("#divSig").hide();
    $(".clsimgSig").attr("src", "");
    $(".clsimgSig").hide();
    this.updateSignaturePreviewInAgreement("");
    if (removeStored) {
      // Remove any previously stored signature when user clears the draw
      try {
        this.removeSignatureFromLocalStorage();
      } catch (e) {
        // ignore
      }
    }
  };

  isValidSigneeName = (name) => {
    return /^[A-Za-z][A-Za-z\s.'-]*$/.test((name || "").trim());
  };

  // Reset canvas to ensure it's ready for drawing after switching modes
  resetCanvas = () => {
    if (this.signaturePad) {
      // Re-size first so the canvas gets a proper width (it may have been
      // sized to 0 when the draw pane was hidden), then clear any stale content.
      this.resizeSignatureCanvas(this.signaturePad, 120);
      this.signaturePad.clear();
    }
  };

  modalHide = () => {
    window.$("#modalAlert").modal("hide");
    this.props.agreementSigned();
  };

  updateSignatureType = (type) => {
    const resellerAccount = auth.getAccount();
    // Soft clear only: switching tabs must never delete a signature stored
    // for another method — the user may switch right back to it.
    this.clear(false);
    const nextState = {
      signature_type: type,
      signatureText:
        type === "choose" || type === "type"
          ? this.state.resellerUserData?.[0]?.name || this.state.resellerUserData?.[0]?.comp_name || (typeof auth.getName === "function" ? auth.getName() : "") || auth.getCompName() || ""
          : "",
      uploadedSignature: "",
      signatureDataUrl: "",
      signatureDrawn: false,
      signatureModalOpen: false,
      modalCanvasEmpty: true,
      errorMessageSignee: "",
      successMessageSignee: "",
    };
    if (type === "type") {
      nextState.signatureClass = "'Dancing Script', cursive";
    }
    if (type === "choose") {
      nextState.signatureClass = localStorage.getItem(`lastSignatureClass_${resellerAccount}`) || "'Amita', cursive";
    }
    if (type === "draw") {
      // Force a clean remount of the draw canvas so signature_pad initializes
      // with the now-visible pane's real dimensions. Without this, a canvas that
      // first mounted while hidden (e.g. after restoring a type/choose signature)
      // keeps a broken backing store and drawn strokes never render/export.
      nextState.drawPadKey = (this.state.drawPadKey || 0) + 1;
    }
    this.setState(nextState, () => {
      // Always clear the live signature preview inside the agreement HTML when switching types
      this.updateSignaturePreviewInAgreement("");
      // Reset file input so re-selecting the same file triggers onChange again
      const uploadInput = document.getElementById("signatureUploadInput");
      if (uploadInput) uploadInput.value = "";
      if (type === "draw") {
        setTimeout(() => {
          this.resetCanvas();
        }, 100);
      }
      if (type === "choose" || type === "type") {
        requestAnimationFrame(() => this.previewTypeSignatureInAgreement());
      }
      // If a signature of this exact type is stored, bring it back so e.g. a
      // drawn signature reappears when the user returns to the Draw tab.
      try {
        const storedType = localStorage.getItem(`lastSignatureType_${resellerAccount}`);
        if (storedType === type) {
          setTimeout(() => this.restoreSignatureFromLocalStorage(), type === "draw" ? 200 : 0);
        }
      } catch (e) {
        // ignore
      }
    });
  };

  handleSignatureUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 2 * 1024 * 1024) {
        window.$("#modalAlertError").modal("show");
        this.setState({ errorMessage: "File size must be less than 2MB." });
        return;
      }
      const reader = new FileReader();
      reader.onload = (event) => {
        const dataUrl = event.target.result;
        // Update the agreement HTML preview synchronously before setState (same
        // pattern as draw signature) so the DOM change isn't lost in a re-render.
        this.updateSignaturePreviewInAgreement(dataUrl);
        this.setState({ uploadedSignature: dataUrl }, () => {
          this.persistSignatureForCarryForward();
        });
      };
      reader.readAsDataURL(file);
    }
  };

  sanitizeFileNamePart = (value, fallback) => {
    const cleaned = (value || "")
      .toString()
      .trim()
      .replace(/[^a-zA-Z0-9\s_-]/g, "")
      .replace(/\s+/g, "_")
      .replace(/_+/g, "_")
      .replace(/^_+|_+$/g, "");
    return cleaned || fallback;
  };

  getAgreementDownloadBaseName = () => {
    const accountNo = this.sanitizeFileNamePart(auth.getAccount(), "account");
    const agreementName = this.sanitizeFileNamePart(
      this.state.agreement_title,
      "agreement"
    );
    return `agreement_${accountNo}_${agreementName}`;
  };

  clearUploadedSignature = (event) => {
    if (event) {
      event.stopPropagation();
    }
    this.setState({ uploadedSignature: "" }, () => {
      const input = document.getElementById("signatureUploadInput");
      if (input) {
        input.value = "";
      }
      this.updateSignaturePreviewInAgreement("");
    });
  };

  isSaveDisabled = () => {
    if (this.state.loadingButton) return true;
    if (this.state.agreement_type === "accept" && this.state.is_checked !== "yes") return true;
    if (this.state.agreement_type === "esign") {
      if (this.state.signature_type === "draw" && !this.state.signatureDrawn) return true;
      if (this.state.signature_type === "choose" && this.state.signatureText === "") return true;
      if (this.state.signature_type === "type" && this.state.signatureText === "") return true;
      if (this.state.signature_type === "upload" && this.state.uploadedSignature === "") return true;
      if (this.state.signature_type === "signee") return true;
    }
    return false;
  };

  handleSignature = (family) => {
    this.setState({ signatureClass: family }, () => {
      requestAnimationFrame(() => this.previewTypeSignatureInAgreement());
    });
    // Save signature style to localStorage for future agreements (user-specific)
    localStorage.setItem(`lastSignatureClass_${auth.getAccount()}`, family);
  };

  formatPhoneNumber = (phoneNumber) => {
    // const phoneNumberObj = parsePhoneNumberFromString(phoneNumber);
    const phoneNumberObj = phoneNumber;
    if (phoneNumberObj) {
      if (phoneNumberObj.country === "US") {
        const nationalNumber = phoneNumberObj
          .formatNational()
          .replace(/\D/g, ""); // e.g. "2123727200"
        const areaCode = nationalNumber.slice(0, 3);
        const firstPart = nationalNumber.slice(3, 6);
        const secondPart = nationalNumber.slice(6);
        return `(${areaCode}) ${firstPart}-${secondPart}`;
      }
      // return phoneNumberObj.formatInternational();
      return phoneNumberObj;
    }
    return phoneNumber; // Return original number if parsing fails
  };

  async componentDidMount() {
    // Standalone/gate usages hide the portal sidebar; embedded page usages
    // (e.g. the Unsigned Agreements page) keep the normal layout.
    if (!this.props.keepSidebar) {
      $(".nk-header-fixed").next(".nk-content").css("margin-left", "0px");

      $(".nk-sidebar .nk-sidebar-fixed")
        .parent()
        .css("display", "none !important");

      $(".nk-sidebar .nk-sidebar-fixed").css("display", "none !important");
    }
    let agreements_type = this.props.agreementsType || "required";
    let apiData = await unsignedAgreements(
      auth.getAccount(),
      auth.getToken(),
      agreements_type
    );
    // console.log("UnSignedAgreement DATA Inner: ", apiData.data);
    if (
      apiData.data.status === 403 ||
      apiData.data.errors === "authentication missing" ||
      apiData.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (apiData.data.status === 404 || !apiData.data.data || apiData.data.data.length === 0) {
      // No unsigned agreements found - all agreements are already signed
      // Notify parent component that agreement is signed
      this.props.agreementSigned();
    } else if (apiData.data.status === 200 && apiData.data.data.length > 0) {
      this.setState({});

      // Normalize company_profile to array so findMatchingSignatories works
      const signatoryArray = Array.isArray(apiData.data.company_profile)
        ? apiData.data.company_profile
        : (apiData.data.company_profile ? [apiData.data.company_profile] : []);

      let get_first_agreement = apiData.data.data[0][6];
      let companyProfileSetting = this.findMatchingSignatories(get_first_agreement, signatoryArray)
        || signatoryArray[0] || {};

      let objReplace = {
        resellerCompName: auth.getCompName(),
        reseller_name: apiData.data.user_data[0]["name"],
        reseller_comp_name: apiData.data.user_data[0]["comp_name"],
        reseller_email: apiData.data.user_data[0]["email"],
        reseller_address: apiData.data.user_data[0]["address"]
          ? apiData.data.user_data[0]["address"]
          : "N/A",
        reseller_city: apiData.data.user_data[0]["city"]
          ? apiData.data.user_data[0]["city"]
          : "N/A",
        reseller_state: apiData.data.user_data[0]["state"]
          ? apiData.data.user_data[0]["state"]
          : "N/A",
        reseller_zip: apiData.data.user_data[0]["zip"]
          ? apiData.data.user_data[0]["zip"]
          : "N/A",
        reseller_country: apiData.data.user_data[0]["country"]
          ? apiData.data.user_data[0]["country"]
          : "N/A",
        reseller_phone_no: this.formatPhoneNumber(
          apiData.data.user_data[0]["phone"]
        ),
        vendor_signor_name: apiData.data.reseller_data[0].reseller_name,
        vendor_signor_comp_name: apiData.data.reseller_data[0].reseller_comp,
        vendor_signor_title: apiData.data.reseller_data[0].reseller_title,
        vendor_signor_address: apiData.data.reseller_data[0].reseller_address
          ? apiData.data.reseller_data[0].reseller_address +
            ", " +
            apiData.data.reseller_data[0].reseller_city +
            ", " +
            apiData.data.reseller_data[0].reseller_state +
            ", " +
            apiData.data.reseller_data[0].reseller_zip
          : " ",
        vendor_signor_email: "N/A",
        vendor_signor_phone_no: apiData.data.reseller_data[0].reseller_phone,
        vendor_signor_fax: "N/A",
        vendor_signor_city: apiData.data.reseller_data[0].reseller_city,
        vendor_signor_state: apiData.data.reseller_data[0].reseller_state,
        vendor_signor_zip: apiData.data.reseller_data[0].reseller_zip,
        vendor_signor_comp_title: apiData.data.reseller_data[0].reseller_comp,

        company_profile_name: companyProfileSetting?.name || apiData.data.reseller_data[0].reseller_name || "N/A",
        company_profile_title: companyProfileSetting?.title || apiData.data.reseller_data[0].reseller_title || "N/A",
        company_profile_address: companyProfileSetting?.address
          ? `${companyProfileSetting.address}`
          : (apiData.data.reseller_data[0].reseller_address || "N/A"),
        company_profile_full_address: companyProfileSetting?.address
          ? `${companyProfileSetting.address}, ${companyProfileSetting.city}, ${companyProfileSetting.state}, ${companyProfileSetting.zip}, ${companyProfileSetting.country}`
          : (apiData.data.reseller_data[0].reseller_address
              ? `${apiData.data.reseller_data[0].reseller_address}, ${apiData.data.reseller_data[0].reseller_city}, ${apiData.data.reseller_data[0].reseller_state}, ${apiData.data.reseller_data[0].reseller_zip}`
              : "N/A"),
        company_profile_city: companyProfileSetting?.city || apiData.data.reseller_data[0].reseller_city || "N/A",
        company_profile_phone: companyProfileSetting?.phone || apiData.data.reseller_data[0].reseller_phone || "N/A",
        company_profile_email: companyProfileSetting?.email || "N/A",
        company_profile_state: companyProfileSetting?.state || apiData.data.reseller_data[0].reseller_state || "N/A",
        company_profile_country: companyProfileSetting?.country || "N/A",
        company_profile_zip: companyProfileSetting?.zip || apiData.data.reseller_data[0].reseller_zip || "N/A",
        company_profile_sign: companyProfileSetting?.sign || "N/A",
        company_profile_company_name: companyProfileSetting?.comp_name || apiData.data.reseller_data[0].reseller_comp || "N/A",
      };

      const vendorSignature = apiData.data.reseller_data[0]?.signature_image
        ? ADMIN_URL + "files_data/logos/" + apiData.data.reseller_data[0].signature_image
        : (apiData.data.reseller_signature || VENDOR_SIGNATURE);

      let final_content = apiData.data.data[0][1];
      this.setState({
        replacable_content: objReplace,
        agreementData: apiData.data.data,
        signatoryData: signatoryArray,
        errorMessage: "",
        final_content: final_content,
        bgColor: "white",
        defaultLoader: false,
        agreement_id: apiData.data.data[0][0],
        agreement_accountno: apiData.data.data[0][6],
        agreement_type: apiData.data.data[0][8],
        agreement_title: apiData.data.data[0][2],
        vendor_signature: vendorSignature,
        signee_token: apiData.data.data[0][9] || "",
        resellerUserData: apiData.data.user_data || [],
        vendorData: apiData.data.reseller_data || [],
        signatureText: apiData.data.user_data[0]["name"] || apiData.data.user_data[0]["comp_name"] || (typeof auth.getName === "function" ? auth.getName() : "") || auth.getCompName() || "",
      }, () => {
        setTimeout(() => this.checkContentScrollable(), 500);
        try {
          if (sessionStorage.getItem(`authConsentConfirmed_${auth.getAccount()}`) === "1") {
            this.setState({ consentChecked: true });
          }
        } catch(e) {}
        // Restore any previously saved signature for this user when agreement opens
        try {
          this.restoreSignatureFromLocalStorage();
        } catch (e) {
          // ignore restore errors
        }
      });
    } else {
      this.setState({
        errorMessage: "There is some error.",
        successMessage: "",
      });
      // console.log("Last Error");
      //this.props.history.push("/error");
    }
  }

  findMatchingSignatories = (agreement_accountno, signatoryArray) => {
    if (!Array.isArray(signatoryArray)) return signatoryArray || null;
    const matchingRecord = signatoryArray.find(
      (record) => String(record.agreement_accountno) === String(agreement_accountno)
    );
    return matchingRecord || null;
  };

  manage_content_with_replacable_data = (agreement_accountno, agreement_content, domIdPrefix = "agreement_content_id_") => {
    const { signatoryData, resellerUserData, vendorData } = this.state;
    if (!resellerUserData.length || !vendorData.length) return null;

    let companyProfileSetting = this.findMatchingSignatories(agreement_accountno, signatoryData)
      || (Array.isArray(signatoryData) && signatoryData[0]) || {};

    let objReplace = {
      resellerCompName: auth.getCompName(),
      reseller_name: resellerUserData[0]["name"],
      reseller_comp_name: resellerUserData[0]["comp_name"],
      reseller_email: resellerUserData[0]["email"],
      reseller_address: resellerUserData[0]["address"] || "N/A",
      reseller_city: resellerUserData[0]["city"] || "N/A",
      reseller_state: resellerUserData[0]["state"] || "N/A",
      reseller_zip: resellerUserData[0]["zip"] || "N/A",
      reseller_country: resellerUserData[0]["country"] || "N/A",
      reseller_phone_no: this.formatPhoneNumber(resellerUserData[0]["phone"]),
      vendor_signor_name: vendorData[0].reseller_name,
      vendor_signor_comp_name: vendorData[0].reseller_comp,
      vendor_signor_title: vendorData[0].reseller_title,
      vendor_signor_address: vendorData[0].reseller_address
        ? `${vendorData[0].reseller_address}, ${vendorData[0].reseller_city}, ${vendorData[0].reseller_state}, ${vendorData[0].reseller_zip}`
        : " ",
      vendor_signor_email: "N/A",
      vendor_signor_phone_no: vendorData[0].reseller_phone,
      vendor_signor_fax: "N/A",
      vendor_signor_city: vendorData[0].reseller_city,
      vendor_signor_state: vendorData[0].reseller_state,
      vendor_signor_zip: vendorData[0].reseller_zip,
      vendor_signor_comp_title: vendorData[0].reseller_comp,
      company_profile_name: companyProfileSetting?.name || vendorData[0].reseller_name || "N/A",
      company_profile_title: companyProfileSetting?.title || vendorData[0].reseller_title || "N/A",
      company_profile_address: companyProfileSetting?.address
        ? `${companyProfileSetting.address}`
        : (vendorData[0].reseller_address || "N/A"),
      company_profile_full_address: companyProfileSetting?.address
        ? `${companyProfileSetting.address}, ${companyProfileSetting.city}, ${companyProfileSetting.state}, ${companyProfileSetting.zip}, ${companyProfileSetting.country}`
        : (vendorData[0].reseller_address
            ? `${vendorData[0].reseller_address}, ${vendorData[0].reseller_city}, ${vendorData[0].reseller_state}, ${vendorData[0].reseller_zip}`
            : "N/A"),
      company_profile_city: companyProfileSetting?.city || vendorData[0].reseller_city || "N/A",
      company_profile_phone: companyProfileSetting?.phone || vendorData[0].reseller_phone || "N/A",
      company_profile_email: companyProfileSetting?.email || "N/A",
      company_profile_state: companyProfileSetting?.state || vendorData[0].reseller_state || "N/A",
      company_profile_country: companyProfileSetting?.country || "N/A",
      company_profile_zip: companyProfileSetting?.zip || vendorData[0].reseller_zip || "N/A",
      company_profile_sign: companyProfileSetting?.sign || "N/A",
      company_profile_company_name: companyProfileSetting?.comp_name || vendorData[0].reseller_comp || "N/A",
    };

    let final_content = REPLACECONTENT(agreement_content, objReplace, "").replace(
      /\[\[IMG_VENDOR_SIGN\]\]/g,
      this.state.vendor_signature || VENDOR_SIGNATURE
    );

    // Handle [[COMPANY_NAME]], [[COMPANY_SIGNOR_NAME]], [[COMPANY_SIGNOR_TITLE]],
    // [[CLIENT_COMPANY_NAME]], [[CLIENT_SIGNOR_NAME]], [[CLIENT_SIGNOR_TITLE]]
    // which REPLACECONTENT does not cover (only REPLACECONTENTCLIENT does via replaceAgreementPlaceholders)
    final_content = replaceAgreementPlaceholders(
      final_content,
      {
        company_profile_company_name: objReplace.company_profile_company_name,
        company_profile_name: objReplace.company_profile_name,
        company_profile_title: objReplace.company_profile_title,
        vendor_signor_comp_name: objReplace.vendor_signor_comp_name,
        vendor_signor_name: objReplace.vendor_signor_name,
        vendor_signor_title: objReplace.vendor_signor_title,
        reseller_comp_name: objReplace.reseller_comp_name,
        resellerCompName: objReplace.resellerCompName,
      },
      {
        comp_name: objReplace.reseller_comp_name,
        name: objReplace.reseller_name,
        title: resellerUserData[0]["title"] || "",
      }
    );

    const scopeClass = `agr-scope-${agreement_accountno}`;
    const { scopedHtml, scopedCss } = scopeAgreementStyles(final_content, scopeClass);
    return (
      <>
        {scopedCss && <style>{scopedCss}</style>}
        <div
          id={`${domIdPrefix}${agreement_accountno}`}
          className={scopeClass}
          dangerouslySetInnerHTML={{ __html: scopedHtml }}
        />
      </>
    );
  };

  getDrawSignaturePayload = () => {
    if (this.signaturePad && !this.signaturePad.isEmpty()) {
      return this.signaturePad.getTrimmedCanvas().toDataURL("image/svg+xml");
    }
    if (this.signaturePadModal && !this.signaturePadModal.isEmpty()) {
      return this.signaturePadModal.getTrimmedCanvas().toDataURL("image/svg+xml");
    }
    return "";
  };

  save = async () => {
    // For "accept" type agreements, always use draw path (no signature needed)
    if (this.state.agreement_type === "accept" || this.state.signature_type === "draw") {
      this.setState({
        errorMessage: "",
        loadingButton: true,
      });
      var data = "";
      if (this.state.agreement_type === "esign") {
        data = this.getDrawSignaturePayload();
        // persist the exact payload used for signing so we can save it after success
        this._lastSavedSignaturePayload = data;
        this._lastSavedSignatureType = this.state.signature_type;
      }
      let content_div_id = "agreement_content_id_" + this.state.agreement_accountno;
      var final_content = document.getElementById(content_div_id).innerHTML;
        const apiData = await saveGeneralAgreement(
          auth.getAccount(),
          auth.getToken(),
          data,
          final_content.replace(
            "VENDOR SIGNATURE DATE SHOWN HERE",
            this.props.published_date
          ),
          this.state.agreement_id,
          this.state.vendor_signature || VENDOR_SIGNATURE,
          this.state.agreement_type
        );
        //console.log("MSA: ", apiData.data);
        if (
          apiData.data.status === 403 ||
          apiData.data.errors === "authentication missing" ||
          apiData.data.errors === "jwt expired"
        ) {
          auth.logout();
        } else if (apiData.data.status === 404) {
          window.$("#modalAlertError").modal("show");
          return this.setState({
            errorMessage: "We are sorry, something went wrong try later.",
            loadingButton: false,
          });

          // this.props.mainHistory.history.push("/error");
          // console.log("errors: ", apiData.data);
        } else if (
          apiData.data.status === 200 &&
          apiData.data.data === "success"
        ) {
          if (this.state.agreement_type === "accept") {
            this.handleAgreementSaveSuccess("The agreement has been accepted successfully.");
          } else {
            this.handleAgreementSaveSuccess("The agreement has been successfully signed.");
          }
        }

        $("#divSig").show();
        $("#divImgSig").show();
        $(".clsimgSig").show();
        $(".clsimgSig").attr("src", data);
        this.markClientPanelAsSigned("agreement_content_id_" + this.state.agreement_accountno, data);
    } else if (this.state.signature_type === "choose" || this.state.signature_type === "type" || this.state.signature_type === "upload") {
      this.setState({ loadingButton: true, errorMessage: "" });
      await this.submitSignatoryDetails();
    }
  };

  submitSignatoryDetails = async () => {
    let { signatureText, signature_type } = this.state;
    this.setState({
      loadingButton: true,
    });
    let is_validated = true;
    if ((signature_type === "choose" || signature_type === "type") && signatureText === "") {
      is_validated = false;
      window.$("#modalAlertError").modal("show");
      this.setState({
        errorMessage: "Please enter the authorized person name.",
        loadingButton: false,
      });
      return;
    }
    if (signature_type === "upload" && this.state.uploadedSignature === "") {
      is_validated = false;
      window.$("#modalAlertError").modal("show");
      this.setState({
        errorMessage: "Please upload a signature image.",
        loadingButton: false,
      });
      return;
    }
    if (!is_validated) {
      this.setState({ loadingButton: false });
      return;
    }
    if (signature_type === "choose" || signature_type === "type") {
      await this.saveAsImage();
    }
    if (signature_type === "upload") {
      await this.saveUploadedSignature();
    }
  };

  saveAsImage = async () => {
    let { signatureText, signature_type } = this.state;
    const elementId = signature_type === "type" ? "typed-text-container" : "styled-text-container";
    const element = document.getElementById(elementId);
    if (element) {
      const origPosition = element.style.position;
      const origTop = element.style.top;
      const origLeft = element.style.left;
      element.style.position = "fixed";
      element.style.top = "0px";
      element.style.left = "-9999px";
      html2canvas(element, { scale: 2, backgroundColor: null }).then(
        async (canvas) => {
          element.style.position = origPosition;
          element.style.top = origTop;
          element.style.left = origLeft;
          const imgData = canvas.toDataURL("image/png");
          let content_div_id = "agreement_content_id_" + this.state.agreement_accountno;
          var final_content = document.getElementById(content_div_id).innerHTML;
          const apiData = await saveChooseSignature(
            auth.getAccount(),
            auth.getToken(),
            imgData,
            signatureText,
            signature_type,
            final_content.replace(
              "VENDOR SIGNATURE DATE SHOWN HERE",
              this.props.published_date
            ),
            this.state.agreement_id,
            this.state.vendor_signature || VENDOR_SIGNATURE,
            this.state.agreement_type
          );
          //console.log("saveSignature: ", apiData.data);
          if (
            apiData.data.status === 403 ||
            apiData.data.errors === "authentication missing" ||
            apiData.data.errors === "jwt expired"
          ) {
            auth.logout();
          } else if (apiData.data.status === 404) {
            this.setState({
              errorMessageSignatory:
                "There is some error while processing your request.",
              successMessageSignatory: "",
              verifyDetailsButton: false,
              disabled: false,
              loadingButton: false,
            });
          } else if (
            apiData.data.status === 200 &&
            apiData.data.data === "success"
          ) {
            if (this.state.agreement_type === "accept") {
              this.handleAgreementSaveSuccess("The agreement has been accepted successfully.");
            } else {
              this.handleAgreementSaveSuccess("The agreement has been successfully signed.");
            }
            this.markClientPanelAsSigned("agreement_content_id_" + this.state.agreement_accountno, imgData);
          }
        }
      );
    }
  };

  saveUploadedSignature = async () => {
    this.setState({ loadingButton: true, errorMessage: "" });
    let { uploadedSignature, signature_type } = this.state;
    // ensure we capture uploadedSignature before API call
    this._lastSavedSignaturePayload = uploadedSignature;
    this._lastSavedSignatureType = signature_type;
    if (uploadedSignature) {
      let content_div_id = "agreement_content_id_" + this.state.agreement_accountno;
      var final_content = document.getElementById(content_div_id).innerHTML;
      const apiData = await saveChooseSignature(
        auth.getAccount(),
        auth.getToken(),
        uploadedSignature,
        "uploaded_signature",
        signature_type,
        final_content.replace(
          "VENDOR SIGNATURE DATE SHOWN HERE",
          this.props.published_date
        ),
        this.state.agreement_id,
        this.state.vendor_signature || VENDOR_SIGNATURE,
        this.state.agreement_type
      );
      if (
        apiData.data.status === 403 ||
        apiData.data.errors === "authentication missing" ||
        apiData.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (apiData.data.status === 404) {
        this.setState({
          errorMessage: "There is some error while processing your request.",
          loadingButton: false,
        });
      } else if (
        apiData.data.status === 200 &&
        apiData.data.data === "success"
      ) {
        this.handleAgreementSaveSuccess("The agreement has been successfully signed.");
        this.markClientPanelAsSigned("agreement_content_id_" + this.state.agreement_accountno, uploadedSignature);
      }
    }
  };

  set_data = (agreement_content) => {
    this.setState({
      final_content: agreement_content,
    });
  };

  _findClientSigElements = (contentDivId) => {
    const contentDiv = document.getElementById(contentDivId);
    if (!contentDiv) return null;
    const sigBlock = Array.from(contentDiv.querySelectorAll("div")).find(
      el => el.style.backgroundColor === "rgb(253, 248, 238)" ||
            (el.getAttribute("style") || "").includes("fdf8ee")
    );
    if (!sigBlock) return null;
    const flexRow = sigBlock.firstElementChild;
    if (!flexRow || flexRow.children.length < 2) return null;
    const clientPanel = flexRow.children[1];
    const body = clientPanel.children[1];
    if (!body || body.children.length < 2) return null;
    return { sigBlock, clientPanel, signatureBox: body.children[1] };
  };

  markClientPanelAsSigned = (contentDivId, dataUrl) => {
    const els = this._findClientSigElements(contentDivId);
    if (!els) return;
    const { clientPanel, signatureBox } = els;

    if (dataUrl) {
      signatureBox.innerHTML = `<img src="${dataUrl}" style="max-width:100%;max-height:80px;object-fit:contain;display:block;margin:0 auto;" alt="Signature" />`;
    }
    signatureBox.style.border = "1.5px solid rgba(22,163,74,0.3)";
    signatureBox.style.background = "rgba(22,163,74,0.04)";
    clientPanel.style.border = "1.5px solid rgba(22,163,74,0.35)";

    const header = clientPanel.firstElementChild;
    if (header) {
      header.style.background = "rgba(22,163,74,0.06)";
      header.style.borderBottom = "1px solid rgba(22,163,74,0.15)";
      const dot = header.querySelector("div");
      if (dot) dot.style.background = "#16a34a";
      const spans = header.querySelectorAll("span");
      if (spans[0]) spans[0].style.color = "#16a34a";
      if (spans[1]) { spans[1].style.color = "#16a34a"; spans[1].textContent = "✓ Signed"; }
    }

    const sigLabel = signatureBox.nextElementSibling;
    if (sigLabel) {
      sigLabel.style.color = "rgba(22,163,74,0.5)";
      sigLabel.style.borderTop = "1px solid rgba(22,163,74,0.15)";
    }

    const today = new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
    clientPanel.querySelectorAll("span").forEach(span => {
      if (span.textContent.trim().toLowerCase().includes("pending")) {
        span.textContent = today;
        span.style.fontStyle = "normal";
        span.style.color = "#3A3D4A";
        span.style.fontWeight = "600";
      }
    });
  };

  // The agreement content is rendered in up to two places at once — the inline
  // panel and the fullscreen reader — each with its own DOM id. Signature
  // previews must be injected into every mounted copy.
  _getAgreementContentIds = () => {
    const accountno = this.state.agreement_accountno;
    return [
      "agreement_content_id_" + accountno,
      "agreement_content_fs_id_" + accountno,
    ];
  };

  updateSignaturePreviewInAgreement = (dataUrl) => {
    this._getAgreementContentIds().forEach((contentDivId) => {
      const contentDiv = document.getElementById(contentDivId);
      if (!contentDiv) return;

      const els = this._findClientSigElements(contentDivId);
      if (els) {
        const { signatureBox } = els;
        if (dataUrl) {
          signatureBox.innerHTML = `<img src="${dataUrl}" style="max-width:100%;max-height:80px;object-fit:contain;display:block;margin:0 auto;" alt="Signature" />`;
        } else {
          signatureBox.innerHTML = `<span style="font-size:17px;font-family:'Dancing Script',cursive;color:#B8B3AD;font-style:italic;">Signature</span>`;
        }
        return;
      }

      const sigImg = contentDiv.querySelector("#imgSig");
      if (sigImg) {
        if (dataUrl) {
          sigImg.removeAttribute("onerror");
          sigImg.src = dataUrl;
          sigImg.style.cssText = "display:block;width:100%;max-width:230px;height:auto;object-fit:contain;";
        } else {
          sigImg.src = "";
          sigImg.style.display = "none";
        }
      }
    });
  };

  previewTypeSignatureInAgreement = () => {
    const { signature_type, signatureText, signatureClass } = this.state;
    if ((signature_type !== "type" && signature_type !== "choose") || !signatureText) return;
    const font = signature_type === "type"
      ? "'Dancing Script', cursive"
      : (signatureClass || "'Dancing Script', cursive");
    this._getAgreementContentIds().forEach((contentDivId) => {
      const els = this._findClientSigElements(contentDivId);
      if (!els) return;
      els.signatureBox.innerHTML = `<span style="font-size:24px;font-family:${font};color:#3A3D4A;">${signatureText}</span>`;
    });
  };

  // Re-inject the currently captured signature preview (used when the
  // fullscreen reader mounts a fresh copy of the agreement content).
  refreshSignaturePreview = () => {
    const { signature_type, signatureDataUrl, uploadedSignature } = this.state;
    if (signature_type === "type" || signature_type === "choose") {
      this.previewTypeSignatureInAgreement();
      return;
    }
    const data = signature_type === "upload"
      ? (uploadedSignature || signatureDataUrl)
      : signatureDataUrl;
    if (data) {
      this.updateSignaturePreviewInAgreement(data);
    }
  };

  // LocalStorage helpers for persisting signature between agreements
  // Persist the signature the moment it is captured (not only after a
  // successful save) so it is prefilled on every subsequent agreement —
  // "enter once, sign each".
  persistSignatureForCarryForward = () => {
    try {
      const resellerAccount = auth.getAccount();
      const type = this.state.signature_type;
      let data = "";
      if (type === "draw") {
        data = this.state.signatureDataUrl || this.getScaledSignatureDataUrl(this.signaturePad) || "";
      } else if (type === "upload") {
        data = this.state.uploadedSignature || this.state.signatureDataUrl || "";
      } else if (type === "type" || type === "choose") {
        data = this.state.signatureText || "";
      }
      if (!type || !data) return;
      this.saveSignatureToLocalStorage({ type, data, className: this.state.signatureClass, resellerAccount });
    } catch (e) {
      // ignore storage errors
    }
  };

  saveSignatureToLocalStorage = ({ type, data, className, resellerAccount }) => {
    try {
      if (!resellerAccount) resellerAccount = auth.getAccount();
      const keyType = `lastSignatureType_${resellerAccount}`;
      const keyData = `lastSignatureData_${resellerAccount}`;
      const keyClass = `lastSignatureClass_${resellerAccount}`;
      const keyTyped = `lastTypedSignature_${resellerAccount}`;

      // Remove any corrupted or empty data
      if (!type || !data) {
        localStorage.removeItem(keyType);
        localStorage.removeItem(keyData);
        return;
      }

      // Store type and data
      localStorage.setItem(keyType, type);
      localStorage.setItem(keyData, data);

      // For typed/choose signatures, also keep typed value and class
      if (type === "type" || type === "choose") {
        if (typeof data === "string") localStorage.setItem(keyTyped, data);
        if (className) localStorage.setItem(keyClass, className);
      } else {
        localStorage.removeItem(keyTyped);
        localStorage.removeItem(keyClass);
      }
    } catch (e) {
      // ignore storage errors
    }
  };

  removeSignatureFromLocalStorage = () => {
    try {
      const resellerAccount = auth.getAccount();
      localStorage.removeItem(`lastSignatureType_${resellerAccount}`);
      localStorage.removeItem(`lastSignatureData_${resellerAccount}`);
      localStorage.removeItem(`lastTypedSignature_${resellerAccount}`);
      localStorage.removeItem(`lastSignatureClass_${resellerAccount}`);
    } catch (e) {
      // ignore
    }
  };

  restoreSignatureFromLocalStorage = () => {
    try {
      const resellerAccount = auth.getAccount();
      const keyType = `lastSignatureType_${resellerAccount}`;
      const keyData = `lastSignatureData_${resellerAccount}`;
      const keyClass = `lastSignatureClass_${resellerAccount}`;
      const keyTyped = `lastTypedSignature_${resellerAccount}`;

      const storedType = localStorage.getItem(keyType);
      const storedData = localStorage.getItem(keyData);
      if (!storedType || !storedData) return;

      // Validate data roughly
      if ((storedType === "draw" || storedType === "upload") && !storedData.startsWith("data:image/")) {
        // corrupted image data, clean up
        this.removeSignatureFromLocalStorage();
        return;
      }

      // helper to retry applying preview until DOM is ready
      const tryApplyPreview = (applyFn, attempts = 6, delay = 200) => {
        let tries = 0;
        const attempt = () => {
          tries += 1;
          try {
            const applied = applyFn();
            // if applied truthy or out of attempts, stop
            if (applied || tries >= attempts) return;
          } catch (e) {
            // ignore and retry
          }
          setTimeout(attempt, delay);
        };
        attempt();
      };

      if (storedType === "draw") {
        this.setState({ signature_type: "draw", signatureDataUrl: storedData, signatureDrawn: true, uploadedSignature: "" }, () => {
          tryApplyPreview(() => {
            this.updateSignaturePreviewInAgreement(storedData);
            const el = document.getElementById("agreement_content_id_" + this.state.agreement_accountno);
            return !!el;
          });
        });
        return;
      }

      if (storedType === "upload") {
        this.setState({ signature_type: "upload", uploadedSignature: storedData, signatureDataUrl: storedData, signatureDrawn: true }, () => {
          tryApplyPreview(() => {
            this.updateSignaturePreviewInAgreement(storedData);
            const el = document.getElementById("agreement_content_id_" + this.state.agreement_accountno);
            return !!el;
          });
        });
        return;
      }

      if (storedType === "type" || storedType === "choose") {
        const typed = localStorage.getItem(keyTyped) || storedData || "";
        const cls = localStorage.getItem(keyClass) || this.state.signatureClass;
        this.setState({ signature_type: storedType, signatureText: typed, signatureClass: cls, signatureDataUrl: "", uploadedSignature: "", signatureDrawn: false }, () => {
          tryApplyPreview(() => {
            requestAnimationFrame(() => this.previewTypeSignatureInAgreement());
            const el = document.getElementById("agreement_content_id_" + this.state.agreement_accountno);
            return !!el;
          });
        });
        return;
      }
    } catch (e) {
      this.removeSignatureFromLocalStorage();
    }
  };

  resetTransientSignatureState = () => {
    this.inlineSignatureStrokes = [];
    this.modalSignatureStrokes = [];
    if (this.signaturePad) {
      this.signaturePad.clear();
    }
    if (this.signaturePadModal) {
      this.signaturePadModal.clear();
    }
    this.updateSignaturePreviewInAgreement("");
  };

  handleAgreementSaveSuccess = (message) => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    // Capture current signature state to persist after successful signing
    const resellerAccount = auth.getAccount();
    const currentSigType = this._lastSavedSignatureType || this.state.signature_type;
    const currentSigClass = this.state.signatureClass;
    let currentSigData = "";
    try {
      if (currentSigType === "draw") {
        currentSigData = this._lastSavedSignaturePayload || this.getScaledSignatureDataUrl(this.signaturePad) || this.state.signatureDataUrl || "";
      } else if (currentSigType === "upload") {
        currentSigData = this._lastSavedSignaturePayload || this.state.uploadedSignature || "";
      } else if (currentSigType === "type" || currentSigType === "choose") {
        currentSigData = this.state.signatureText || "";
      }
    } catch (e) {
      currentSigData = "";
    }

    this.resetTransientSignatureState();

    this.setState({
      successMessage: "",
      errorMessage: "",
      toastMessage: message,
      toastType: "success",
      toastTitle: this.state.agreement_type === "accept" ? "Agreement Accepted" : "Agreement Signed",
      loadingButton: false,
      disabled: false,
      is_checked: "",
      signatureDrawn: false,
      signatureText: "",
      uploadedSignature: "",
      signatureDataUrl: "",
      signatureModalOpen: false,
      modalCanvasEmpty: true,
      signature_type: "draw",
      signatureColor: "#000000",
      showSigneeForm: false,
      currentStep: 1,
      scrollProgress: 0,
      hasReachedEndOnce: false,
      consentChecked: false,
    });

    // Persist signature only after successful signing
    try {
      this.saveSignatureToLocalStorage({ type: currentSigType, data: currentSigData, className: currentSigClass, resellerAccount });
    } catch (e) {
      // ignore storage errors
    }
    // clear temporary captured payload
    try {
      delete this._lastSavedSignaturePayload;
      delete this._lastSavedSignatureType;
    } catch (e) {}

    const isLastAgreement = this.state.agreementData.length <= 1;
    const targetIndex = this.state.activeTabIndex;
    setTimeout(async () => {
      this.setState({ successMessage: "" });
      await this.componentDidMount();
      if (!isLastAgreement) {
        const newData = this.state.agreementData;
        if (newData && newData.length > 0) {
          const idx = Math.min(targetIndex, newData.length - 1);
          this.show_agreement_content(
            newData[idx][0], newData[idx][1], newData[idx][8], newData[idx][2]
          );
        }
      }
    }, 3000);
  };

  open_signee = async () => {
    this.setState({
      errorMessageSignee: "",
      successMessageSignee: "",
      characterExceededMessage: "",
      signee_comment: "",
      ccList: [],
      ccOpen: false,
      showSigneeForm: true,
    });
  };

  close_signee = async () => {
    this.setState({
      showSigneeForm: false,
    });
  };

  getSigneeFormResetState = () => ({
    errorMessageSignee: "",
    successMessageSignee: "",
    characterExceededMessage: "",
    signee_name: "",
    signee_email: "",
    signee_title: "",
    signee_comment: "",
    ccList: [],
    ccOpen: false,
    showSigneeForm: false,
    button_submit_loader: false,
    disabled: false,
  });

  send_to_signee = async () => {
    // console.log("agreement_id: " + this.state.agreement_id);
    this.setState({
      successMessageSignee: "",
      errorMessageSignee: "",
      disabled: true,
    });
    const {
      agreement_id,
      signee_name,
      signee_email,
      signee_title,
      signee_comment,
      agreement_type,
    } = this.state;

    var validated = true;
    if (signee_name === "") {
      validated = false;
    } else if (!this.isValidSigneeName(signee_name)) {
      validated = false;
      this.setState({
        errorMessageSignee: "Name can include only letters, spaces, apostrophes, periods, and hyphens.",
      });
    } else if (signee_email === "") {
      validated = false;
    } else if (ValidateEmail(signee_email) === false) {
      validated = false;
      this.setState({
        errorEmail: "error",
        errorMessageSignee: "Invalid email format.",
      });
    } else if (signee_comment === "") {
      validated = false;
    }

    if (validated === false) {
      this.setState({
        errorMessageSignee: "Please enter the required fields.",
        disabled: false,
      });
    } else {
      const apiData = await sendToSignee(
        auth.getAccount(),
        auth.getToken(),
        agreement_id,
        signee_name,
        signee_email,
        signee_title,
        signee_comment,
        agreement_type
      );
      //console.log("sendToSignee: ", apiData.data);
      if (
        apiData.data.status === 403 ||
        apiData.data.errors === "authentication missing" ||
        apiData.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (apiData.data.status === 404) {
        this.setState({
          errorMessageSignee: "We are sorry, something went wrong try later.",
          disabled: false,
        });
        // this.props.mainHistory.history.push("/error");
        // console.log("errors: ", apiData.data);
      } else if (
        apiData.data.status === 200 &&
        apiData.data.message === "success"
      ) {
        this.setState({
          successMessageSignee: "",
          errorMessageSignee: "",
          toastMessage: "Agreement has been sent successfully to the signee.",
          toastType: "success",
          toastTitle: "Email Sent",
        });
        localStorage.setItem(`lastSignatureType_${auth.getAccount()}`, "draw");
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
    }
  };

  handleChangeTextArea = (event) => {
    let { value } = event.target;
    const { charLimit } = this.state;

    // Update state only if the character limit is not exceeded

    if (value.length <= charLimit) {
      this.setState({ signee_comment: value, characterExceededMessage: "" });
    } else {
      //value = value.slice(0, charLimit);
      this.setState({
        characterExceededMessage: `Character limit exceeded. Maximum 500 characters are allowed. you have entered ${value.length} characters.`,
      });
    }
  };

  handleChange = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.value : target.value;
    const { name } = target;

    if (name === "signee_name") {
      const sanitizedName = value.replace(/[^A-Za-z\s.'-]/g, "");
      if (sanitizedName.length > 30) return;
      this.setState({ signee_name: sanitizedName });
      return;
    }

    if (name === "signee_title" && value.length > 30) return;

    if (name === "signatureText") {
      this.setState({ [name]: value }, () => {
        requestAnimationFrame(() => this.previewTypeSignatureInAgreement());
        this.persistSignatureForCarryForward();
      });
      localStorage.setItem(`lastTypedSignature_${auth.getAccount()}`, value);
      return;
    }

    this.setState({
      [name]: value,
    });
    //console.log("handleChange: ", name + " " + value);
  };

  preview = () => {
    if (!this.signaturePad.isEmpty()) {
      var data = this.getScaledSignatureDataUrl(this.signaturePad);
      $("#divSig").show();
      //$("#divImgSig").show();
      $(".clsimgSig").show();
      $(".clsimgSig").attr("src", data);
    }
  };

  class_manage_link = (ids) => {
    if (ids === this.state.activeTabIndex) {
      return "nav-link active";
    } else {
      return "nav-link";
    }
  };

  class_manage_content = (ids) => {
    if (ids === this.state.activeTabIndex) {
      return "tab-pane active";
    } else {
      return "tab-pane";
    }
  };

  class_required = (ids) => {
    if (ids === 1) {
      return (
        <sup style={{ fontSize: "100%" }}>
          <small className="" style={{ color: "#e85347", fontSize: "100%" }}>
            *
          </small>
        </sup>
      );
    } else {
      return "";
    }
  };

  set_tabs = (ids) => {
    if (ids !== "") {
      return "#agreement" + ids;
    } else {
      return "tab-pane";
    }
  };

  set_tabs_content = (ids) => {
    if (ids !== "") {
      return "agreement" + ids;
    } else {
      return "tab-pane";
    }
  };

  show_agreement_content = async (
    ids,
    agreement_content,
    agreement_type,
    agreement_title
  ) => {
    const tabIndex = this.state.agreementData.findIndex(a => a[0] === ids);
    const tab = this.state.agreementData.find(a => a[0] === ids);
    const agreement_accountno = tab ? tab[6] : "";
    this.setState({
      final_content: agreement_content,
      agreement_id: ids,
      agreement_accountno: agreement_accountno,
      agreement_type: agreement_type,
      agreement_title: agreement_title,
      activeTabIndex: tabIndex >= 0 ? tabIndex : 0,
      verifyDetailsButton: false,
      signatureDrawn: false,
      is_checked: "",
      signatureText: "",
      uploadedSignature: "",
      signatureDataUrl: "",
      signatureModalOpen: false,
      modalCanvasEmpty: true,
      ...this.getSigneeFormResetState(),
      signature_type: "draw",
      loadingButton: false,
      scrollProgress: 0,
      hasReachedEndOnce: false,
      inlineAtBottom: false,
      fullscreenAtBottom: false,
      consentChecked: (() => { try { return sessionStorage.getItem(`authConsentConfirmed_${auth.getAccount()}`) === "1"; } catch(e) { return false; } })(),
      currentStep: 1,
    }, () => {
      if (this.signaturePad) this.signaturePad.clear();
      // A new document must start reading from the top — the shared scroll
      // containers keep the previous agreement's position otherwise.
      if (this.scrollContainerRef) this.scrollContainerRef.scrollTop = 0;
      if (this.fullscreenScrollRef) this.fullscreenScrollRef.scrollTop = 0;
      setTimeout(() => {
        this.resizeSignatureCanvas(this.signaturePad, 120);
        this.checkContentScrollable();
        try {
          this.restoreSignatureFromLocalStorage();
        } catch (e) {
          // ignore
        }
      }, 300);
    });
  };

  handlePrint = () => {
    // Target the div element by ID
    const activeTabPane = document.querySelector(".tab-pane.active");
    const activeTabId = activeTabPane.id;
    const printableElement = document.getElementById(activeTabId);

    // Check if the element exists
    if (printableElement) {
      // Open a new window for printing
      const printWindow = window.open("", "_blank");

      // Append the content of the div to the new window for printing
      printWindow.document.write(printableElement.innerHTML);

      // Trigger the print dialog for the new window
      printWindow.print();

      // Close the new window after printing
      printWindow.close();
    } else {
      console.error("Element not found: contentToPrint");
    }
  };

  copyTextToClipboard = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.setState({ copied: true });

        setTimeout(() => {
          this.setState({ copied: false });
        }, 2000);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
        window.$("#modalAlertError").modal("show");
        this.setState({
          errorMessage: "Failed to copy the signee link to clipboard.",
        });
      });
  };

  copySigneeLink = async () => {
    const activeTabPane = document.querySelector(".tab-pane.active");
    if (!activeTabPane) {
      window.$("#modalAlertError").modal("show");
      this.setState({
        errorMessage: "No active agreement tab found.",
      });
      return;
    }

    const activeTabId = activeTabPane.id;
    const agreementAccountNo = activeTabId.replace("agreement", "");

    const activeAgreement = this.state.agreementData.find(
      (agreement) => agreement[6] === agreementAccountNo
    );

    if (!activeAgreement) {
      window.$("#modalAlertError").modal("show");
      this.setState({
        errorMessage: "Could not find agreement data for the active tab.",
      });
      return;
    }

    const signeeToken = activeAgreement[9] || this.state.signee_token;

    if (signeeToken) {
      const signeeLink = `${APP_LIVE_URL}${auth.getResellerRegToken()}/agreements_verification/${signeeToken}`;
      this.copyTextToClipboard(signeeLink);
      return;
    }

    if (this.state.preparedSigningUrl) {
      this.copyTextToClipboard(this.state.preparedSigningUrl);
      return;
    }

    this.setState({ copyLinkLoading: true });
    try {
      const apiData = await prepareSigneeLink(
        auth.getAccount(),
        auth.getToken(),
        this.state.agreement_accountno
      );
      if (apiData.data.status === 200 && apiData.data.signing_url) {
        this.setState({
          preparedSigningUrl: apiData.data.signing_url,
          copyLinkLoading: false,
        });
        this.copyTextToClipboard(apiData.data.signing_url);
      } else {
        this.setState({ copyLinkLoading: false });
        window.$("#modalAlertError").modal("show");
        this.setState({
          errorMessage: "Failed to generate a signee link for this agreement.",
        });
      }
    } catch (err) {
      console.error("Failed to prepare signee link: ", err);
      this.setState({ copyLinkLoading: false });
      window.$("#modalAlertError").modal("show");
      this.setState({
        errorMessage: "Failed to generate a signee link for this agreement.",
      });
    }
  };

  hasSigneeToken = () => {
    if (!this.state.agreement_id || !this.state.agreementData.length) {
      return false;
    }
    const activeAgreement = this.state.agreementData.find(
      (agreement) => agreement[0] === this.state.agreement_id
    );
    return (
      activeAgreement && activeAgreement[9] && activeAgreement[9].trim() !== ""
    );
  };

  handleDownload = async () => {
    const activeTabPane = document.querySelector(".tab-pane.active");
    if (!activeTabPane) {
      console.error("Active tab pane not found");
      return;
    }
    const documentTitle = this.getAgreementDownloadBaseName();

    const agreementContent = activeTabPane.querySelector(
      '[id^="agreement_content_"]'
    );
    if (!agreementContent) {
      console.error("Agreement content not found");
      return;
    }

    const normalizeText = (text = "") =>
      text.replace(/[\u200B-\u200D\uFEFF]/g, "").replace(/\u00a0/g, " ");

    const isMeaningfulText = (text = "") => normalizeText(text).trim() !== "";
    const PAGE_BREAK_CLASS = "rte-page-break";

    const pxToHalfPoints = (px, fallback = 24) => {
      const numericPx = parseFloat(px || "0");
      if (!numericPx) {
        return fallback;
      }
      return Math.max(16, Math.round(numericPx * 1.5));
    };

    const getHeadingConfig = (tagName) => {
      const configs = {
        h1: { level: HeadingLevel.HEADING_1, size: 36 },
        h2: { level: HeadingLevel.HEADING_2, size: 32 },
        h3: { level: HeadingLevel.HEADING_3, size: 28 },
        h4: { level: HeadingLevel.HEADING_4, size: 26 },
        h5: { level: HeadingLevel.HEADING_5, size: 24 },
        h6: { level: HeadingLevel.HEADING_6, size: 22 },
      };
      return configs[tagName] || null;
    };

    const getAlignment = (element) => {
      if (!element || element.nodeType !== Node.ELEMENT_NODE) {
        return AlignmentType.LEFT;
      }

      const inlineAlign = element.style?.textAlign || "";
      const computedAlign = window.getComputedStyle(element).textAlign || "";
      const align = (inlineAlign || computedAlign || "").toLowerCase();

      if (align === "center") return AlignmentType.CENTER;
      if (align === "right" || align === "end") return AlignmentType.RIGHT;
      if (align === "justify") return AlignmentType.JUSTIFIED;
      return AlignmentType.LEFT;
    };

    const getIndent = (element) => {
      if (!element || element.nodeType !== Node.ELEMENT_NODE) {
        return undefined;
      }

      const styles = window.getComputedStyle(element);
      const marginLeft = parseFloat(styles.marginLeft || "0");
      const paddingLeft = parseFloat(styles.paddingLeft || "0");
      const pxIndent = Math.max(0, marginLeft + paddingLeft);

      if (!pxIndent) {
        return undefined;
      }

      return { left: Math.round(pxIndent * 15) };
    };

    const getSpacing = (element, fallback = {}) => {
      if (!element || element.nodeType !== Node.ELEMENT_NODE) {
        return fallback;
      }

      const styles = window.getComputedStyle(element);
      const before = Math.round(parseFloat(styles.marginTop || "0") * 15);
      const after = Math.round(parseFloat(styles.marginBottom || "0") * 15);

      return {
        before: before || fallback.before || 0,
        after: after || fallback.after || 120,
        line: fallback.line || 276,
      };
    };

    const getRunStyleFromElement = (element, inherited = {}) => {
      if (!element || element.nodeType !== Node.ELEMENT_NODE) {
        return inherited;
      }

      const tag = element.tagName.toLowerCase();
      const styles = window.getComputedStyle(element);
      const headingConfig = getHeadingConfig(tag);
      const nextOptions = { ...inherited };
      const fontWeight = styles.fontWeight || "";
      const textDecorationLine = styles.textDecorationLine || "";
      const verticalAlign = styles.verticalAlign || "";

      if (
        tag === "strong" ||
        tag === "b" ||
        fontWeight === "bold" ||
        Number(fontWeight) >= 600
      ) {
        nextOptions.bold = true;
      }

      if (tag === "em" || tag === "i" || styles.fontStyle === "italic") {
        nextOptions.italics = true;
      }

      if (tag === "u" || textDecorationLine.includes("underline")) {
        nextOptions.underline = { type: UnderlineType.SINGLE };
      }

      if (tag === "sup" || verticalAlign === "super") {
        nextOptions.superScript = true;
      }

      if (tag === "sub" || verticalAlign === "sub") {
        nextOptions.subScript = true;
      }

      if (styles.fontFamily) {
        const fontFamily = styles.fontFamily.split(",")[0].replace(/["']/g, "");
        if (fontFamily) {
          nextOptions.font = fontFamily;
        }
      }

      if (styles.color && styles.color !== "rgb(0, 0, 0)") {
        const rgb = styles.color.match(/\d+/g);
        if (rgb && rgb.length >= 3) {
          nextOptions.color = rgb
            .slice(0, 3)
            .map((value) => Number(value).toString(16).padStart(2, "0"))
            .join("")
            .toUpperCase();
        }
      }

      nextOptions.size = headingConfig
        ? headingConfig.size
        : pxToHalfPoints(styles.fontSize, inherited.size || 24);

      return nextOptions;
    };

    const createTextRun = (text, options = {}) =>
      new TextRun({
        text: normalizeText(text),
        font: "Times New Roman",
        size: 24,
        ...options,
      });

    const createPlainParagraphFromText = (text, options = {}) => {
      if (!isMeaningfulText(text)) {
        return null;
      }

      return new Paragraph({
        spacing: options.spacing || { after: 120, line: 276 },
        alignment: options.alignment || AlignmentType.LEFT,
        indent: options.indent,
        children: [createTextRun(text)],
      });
    };

    const getImageData = async (src) => {
      if (!src) {
        return null;
      }

      if (src.startsWith("data:")) {
        const base64 = src.split(",")[1];
        if (!base64) {
          return null;
        }
        const binary = window.atob(base64);
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i += 1) {
          bytes[i] = binary.charCodeAt(i);
        }
        return bytes;
      }

      try {
        const response = await fetch(src);
        const buffer = await response.arrayBuffer();
        return new Uint8Array(buffer);
      } catch (error) {
        console.error("Failed to fetch image for docx export:", error);
        return null;
      }
    };

    const createRunsFromNode = async (node, inherited = {}) => {
      if (node.nodeType === Node.TEXT_NODE) {
        if (!isMeaningfulText(node.textContent)) {
          return [];
        }
        return [createTextRun(node.textContent, inherited)];
      }

      if (node.nodeType !== Node.ELEMENT_NODE) {
        return [];
      }

      const tag = node.tagName.toLowerCase();
      const nextOptions = getRunStyleFromElement(node, inherited);

      if (tag === "br") {
        return [new TextRun({ break: 1 })];
      }

      if (tag === "img") {
        const imageData = await getImageData(node.getAttribute("src"));
        if (!imageData) {
          return [];
        }

        const width =
          parseInt(node.getAttribute("width"), 10) ||
          Math.round(node.clientWidth) ||
          180;
        const height =
          parseInt(node.getAttribute("height"), 10) ||
          Math.round(node.clientHeight) ||
          60;

        return [
          new ImageRun({
            data: imageData,
            transformation: {
              width: Math.min(width, 520),
              height: Math.min(height, 220),
            },
          }),
        ];
      }

      let runs = [];
      for (const child of Array.from(node.childNodes)) {
        const childRuns = await createRunsFromNode(child, nextOptions);
        runs = runs.concat(childRuns);
      }
      return runs;
    };

    const createParagraphFromElement = async (
      element,
      options = {}
    ) => {
      const runs = await createRunsFromNode(element);
      const nonEmptyRuns = runs.filter((run) => run);
      const headingConfig = getHeadingConfig(element.tagName.toLowerCase());

      if (!nonEmptyRuns.length) {
        return null;
      }

      return new Paragraph({
        heading: options.heading || headingConfig?.level,
        alignment: options.alignment || getAlignment(element),
        indent: options.indent || getIndent(element),
        spacing: options.spacing || getSpacing(element, { after: 120 }),
        bullet: options.bullet,
        children: options.prefix
          ? [createTextRun(options.prefix), ...nonEmptyRuns]
          : nonEmptyRuns,
      });
    };

    const createTableFromElement = async (tableElement) => {
      const rows = [];
      const trElements = Array.from(tableElement.querySelectorAll("tr"));

      for (const tr of trElements) {
        const cells = [];
        const cellElements = Array.from(tr.children).filter((child) =>
          ["td", "th"].includes(child.tagName.toLowerCase())
        );

        for (const cellElement of cellElements) {

          const nestedTable = cellElement.querySelector(":scope > table, :scope > tbody > tr > td > table");
          
          if (nestedTable) {
            // Cell has nested table � extract all its paragraphs
            const nestedTrElements = Array.from(
              nestedTable.querySelectorAll(":scope > tbody > tr, :scope > tr")
            );
            
            const cellParagraphs = [];
            
            for (const nestedTr of nestedTrElements) {
              const nestedCells = Array.from(nestedTr.children).filter((child) =>
                ["td", "th"].includes(child.tagName.toLowerCase())
              );
              
              for (const nestedCell of nestedCells) {
                const para = (await createParagraphFromElement(nestedCell, {
                  spacing: { after: 80, line: 240 },
                })) || new Paragraph({ children: [createTextRun("")] });
                
                cellParagraphs.push(para);
              }
            }
            
            cells.push(
              new TableCell({
                children: cellParagraphs.length 
                  ? cellParagraphs 
                  : [new Paragraph({ children: [createTextRun("")] })],
              })
            );
            
          } else {
            // No nested table � process cell normally as before
            const paragraph =
              (await createParagraphFromElement(cellElement, {
                spacing: { after: 80, line: 240 },
              })) ||
              new Paragraph({ children: [createTextRun("")] });

            cells.push(
              new TableCell({
                children: [paragraph],
              })
            );
          }
        }

        if (cells.length) {
          rows.push(new TableRow({ children: cells }));
        }
      }

      if (!rows.length) {
        return null;
      }

      return new Table({
        rows,
        width: {
          size: 5000,
          type: WidthType.PERCENTAGE,
        },
        borders: {
          top: { style: BorderStyle.NONE, size: 0, color: "ffffff" },
          bottom: { style: BorderStyle.NONE, size: 0, color: "ffffff" },
          left: { style: BorderStyle.NONE, size: 0, color: "ffffff" },
          right: { style: BorderStyle.NONE, size: 0, color: "ffffff" },
          insideHorizontal: {
            style: BorderStyle.NONE,
            size: 0,
            color: "ffffff",
          },
          insideVertical: {
            style: BorderStyle.NONE,
            size: 0,
            color: "ffffff",
          },
        },
      });
    };

    const processList = async (listElement, ordered = false) => {
      const listItems = [];
      const items = Array.from(listElement.children).filter(
        (child) => child.tagName.toLowerCase() === "li"
      );

      for (const [index, item] of items.entries()) {
        const prefix = ordered ? `${index + 1}. ` : "\u2022 ";
        const paragraph = await createParagraphFromElement(item, {
          prefix,
          indent: { left: convertInchesToTwip(0.3) },
          spacing: { after: 80, line: 260 },
        });

        if (paragraph) {
          listItems.push(paragraph);
        }

        const nestedLists = Array.from(item.children).filter((child) =>
          ["ul", "ol"].includes(child.tagName.toLowerCase())
        );

        for (const nestedList of nestedLists) {
          const nestedItems = await processList(
            nestedList,
            nestedList.tagName.toLowerCase() === "ol"
          );
          listItems.push(...nestedItems);
        }
      }

      return listItems;
    };

    const isPageBreakElement = (element) =>
      element &&
      element.nodeType === Node.ELEMENT_NODE &&
      element.classList.contains(PAGE_BREAK_CLASS);

    const createPageBreakParagraph = () =>
      new Paragraph({
        pageBreakBefore: true,
        spacing: { before: 0, after: 0, line: 240 },
        children: [new TextRun("")],
      });

    const processNode = async (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const paragraph = createPlainParagraphFromText(node.textContent);
        return paragraph ? [paragraph] : [];
      }

      if (node.nodeType !== Node.ELEMENT_NODE) {
        return [];
      }

      return processElement(node);
    };

    const processElement = async (element) => {
      const tag = element.tagName.toLowerCase();
      const blockTags = new Set([
        "div",
        "section",
        "article",
        "header",
        "footer",
        "main",
      ]);
      const nestedBlockTags = new Set([
        "p",
        "div",
        "table",
        "ol",
        "ul",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "section",
        "article",
        "header",
        "footer",
        "main",
      ]);

      if (isPageBreakElement(element)) {
        return [createPageBreakParagraph()];
      }

      // Flatten vertical-text elements (writing-mode: vertical-*) into one paragraph
      // so characters don't end up as separate lines in the DOCX output.
      const inlineWritingMode = (element.getAttribute("style") || "").replace(/\s/g, "").toLowerCase();
      if (inlineWritingMode.includes("writing-mode:vertical")) {
        const flatText = element.textContent.trim();
        if (!flatText) return [];
        const para = new Paragraph({
          spacing: { after: 120, line: 276 },
          children: [createTextRun(flatText)],
        });
        return [para];
      }

      if (tag === "table") {
        const table = await createTableFromElement(element);
        return table ? [table] : [];
      }

      if (tag === "ol" || tag === "ul") {
        return processList(element, tag === "ol");
      }

      const hasDirectBlockChildren = Array.from(element.childNodes).some((child) => {
        if (child.nodeType !== Node.ELEMENT_NODE) {
          return false;
        }

        return (
          nestedBlockTags.has(child.tagName.toLowerCase()) ||
          isPageBreakElement(child)
        );
      });

      if (blockTags.has(tag) && hasDirectBlockChildren) {
        let nestedElements = [];
        for (const child of Array.from(element.childNodes)) {
          const processed = await processNode(child);
          nestedElements = nestedElements.concat(processed);
        }
        return nestedElements;
      }

      const paragraph = await createParagraphFromElement(element, {
        alignment: getAlignment(element),
        heading: getHeadingConfig(tag)?.level,
        spacing:
          /^h[1-6]$/.test(tag)
            ? getSpacing(element, { before: 120, after: 140, line: 260 })
            : getSpacing(element, { after: 120 }),
      });

      return paragraph ? [paragraph] : [];
    };

    // Clone content and replace the coloured signature block with clean data-only paragraphs
    const contentClone = agreementContent.cloneNode(true);
    const sigBlockEl = Array.from(contentClone.querySelectorAll("div")).find(el => {
      const style = el.getAttribute("style") || "";
      return (
        el.style.backgroundColor === "rgb(253, 248, 238)" ||
        style.toLowerCase().includes("fdf8ee")
      );
    });
    console.log("[DOCX export] signature block found:", !!sigBlockEl);
    if (sigBlockEl) {
      const flexDivEl = sigBlockEl.firstElementChild;
      if (flexDivEl) {
        // Use plain sequential paragraphs (no table) so each line spans the
        // full page width. Tables in docx were rendering with very narrow
        // cells causing character-per-line wrapping.
        const sigContainer = document.createElement("div");
        const cards = Array.from(flexDivEl.children);
        console.log("[DOCX export] signature panel cards:", cards.length);

        const extractFieldsFromPanel = (panel) => {
          const fields = {};
          const allRows = panel.querySelectorAll("div, p");
          allRows.forEach((row) => {
            const spans = row.querySelectorAll("span");
            if (spans.length >= 2) {
              const label = spans[0].textContent.trim().toLowerCase();
              const value = spans[1].textContent.trim();
              if (label === "signer" || label === "signer:") fields.signer = value;
              else if (label === "title" || label === "title:") fields.title = value;
              else if (label === "date" || label === "date:") fields.date = value;
            }
          });
          return fields;
        };

        const extractOrgName = (panel) => {
          const boldEls = panel.querySelectorAll("strong, b, h1, h2, h3, h4, h5, h6");
          for (const el of boldEls) {
            const txt = el.textContent.trim();
            if (txt) return txt;
          }
          const allEls = panel.querySelectorAll("div");
          for (const el of allEls) {
            const fw = el.style.fontWeight || "";
            const txt = el.textContent.trim();
            if ((fw === "bold" || parseInt(fw, 10) >= 600) && txt && txt.length < 80) {
              return txt;
            }
          }
          return "";
        };

        cards.forEach((card, idx) => {
          const orgName = extractOrgName(card);
          const sigImg = card.querySelector("img");
          const fields = extractFieldsFromPanel(card);
          const partyLabel = idx === 0 ? "Disclosing Party" : "Receiving Party";

          const html = [];
          html.push(`<p><b>${partyLabel}: ${orgName}</b></p>`);
          if (sigImg && sigImg.src) {
            html.push(`<p><img src="${sigImg.src}" style="max-width:180px;max-height:60px;" /></p>`);
            html.push("<p><i>Authorized Signature</i></p>");
          } else {
            html.push("<p><i>Pending counter-signature</i></p>");
          }
          html.push("<p>Name: <b>" + (fields.signer || "") + "</b></p>");
          html.push("<p>Title: <b>" + (fields.title || "") + "</b></p>");
          html.push("<p>Date: " + (fields.date || "— pending —") + "</p>");
          if (idx < cards.length - 1) {
            html.push("<p>&nbsp;</p>");
          }
          const wrapper = document.createElement("div");
          wrapper.innerHTML = html.join("");
          while (wrapper.firstChild) {
            sigContainer.appendChild(wrapper.firstChild);
          }
        });
        sigBlockEl.parentNode.replaceChild(sigContainer, sigBlockEl);
      } else {
        sigBlockEl.remove();
      }
    }

    let docElements = [];
    for (const child of Array.from(contentClone.childNodes)) {
      const processed = await processNode(child);
      docElements = docElements.concat(processed);
    }

    if (!docElements.length && isMeaningfulText(contentClone.textContent)) {
      const fallbackParagraph = new Paragraph({
        spacing: { after: 120, line: 276 },
        children: [createTextRun(contentClone.textContent)],
      });
      docElements = [fallbackParagraph];
    }

    const cleanedDocElements = docElements.filter(Boolean);
    if (!cleanedDocElements.length) {
      console.error("No agreement content available for DOCX export");
      return;
    }

    const doc = new Document({
      sections: [
        {
          properties: {
            page: {
              margin: {
                top: convertInchesToTwip(0.35),
                right: convertInchesToTwip(0.45),
                bottom: convertInchesToTwip(0.35),
                left: convertInchesToTwip(0.45),
              },
            },
          },
          children: cleanedDocElements,
        },
      ],
    });

    Packer.toBlob(doc)
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${documentTitle}.docx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error generating document:", error);
      });
  };

  openSignatureModal = () => {
    const inlineStrokes = this.getSignatureStrokes(this.signaturePad);
    const hasInlineSignature = inlineStrokes.length > 0;
    const fallbackStrokes = this.modalSignatureStrokes.length
      ? this.cloneSignatureStrokes(this.modalSignatureStrokes)
      : [];

    this.inlineSignatureStrokes = hasInlineSignature
      ? inlineStrokes
      : this.inlineSignatureStrokes;
    this.modalSignatureStrokes = hasInlineSignature
      ? this.cloneSignatureStrokes(inlineStrokes)
      : fallbackStrokes;

    const hasSavedDrawState = this.modalSignatureStrokes.length > 0;
    this.setState({ signatureModalOpen: true, modalCanvasEmpty: !hasSavedDrawState }, () => {
      setTimeout(() => {
        this.applySignatureStrokes(this.signaturePadModal, this.modalSignatureStrokes);
      }, 100);
    });
  };

  isElAtBottom = (el, offset = 5) =>
    !!el && el.scrollHeight - el.scrollTop - el.clientHeight <= offset;

  // Track whether each reading container is currently at its bottom so the
  // Jump-to-bottom pill can hide at the end and reappear on scrolling up.
  getAtBottomFlagUpdate = (el) => {
    const update = {};
    if (el && el === this.scrollContainerRef) {
      update.inlineAtBottom = this.isElAtBottom(el);
    }
    if (el && el === this.fullscreenScrollRef) {
      update.fullscreenAtBottom = this.isElAtBottom(el, 80);
    }
    return update;
  };

  handleDocumentScroll = (e) => {
    const flagUpdate = this.getAtBottomFlagUpdate(e.target);
    const isFullscreenTarget = !!this.fullscreenScrollRef && e.target === this.fullscreenScrollRef;
    const fullscreenReadComplete = isFullscreenTarget && this.isElAtBottom(e.target, 80);

    // Once the document has been fully read (in any view — inline or
    // fullscreen), keep the progress pinned at 100% so the user is never
    // asked to re-read after switching views.
    if (this.state.hasReachedEndOnce) {
      this.setState((prevState) => ({
        ...flagUpdate,
        fullscreenReadComplete: prevState.fullscreenReadComplete || prevState.hasReachedEndOnce || (isFullscreenTarget && fullscreenReadComplete),
        scrollProgress: 100,
      }));
      return;
    }
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - clientHeight > 0) {
      const progress = Math.round((scrollTop / (scrollHeight - clientHeight)) * 100);
      const clamped = Math.min(progress, 100);
      const reachedEnd = isFullscreenTarget ? fullscreenReadComplete : clamped >= 100;
      this.setState((prevState) => ({
        ...flagUpdate,
        scrollProgress: reachedEnd ? 100 : clamped,
        hasReachedEndOnce: prevState.hasReachedEndOnce || reachedEnd,
        fullscreenReadComplete: prevState.fullscreenReadComplete || reachedEnd,
      }));
    } else if (Object.keys(flagUpdate).length > 0) {
      this.setState((prevState) => ({
        ...flagUpdate,
        fullscreenReadComplete: prevState.fullscreenReadComplete || (isFullscreenTarget && fullscreenReadComplete),
      }));
    }
  };

  checkContentScrollable = () => {
    const el = this.scrollContainerRef;
    if (el) {
      if (el.scrollHeight <= el.clientHeight + 5) {
        this.setState({ scrollProgress: 100, hasReachedEndOnce: true, inlineAtBottom: true });
      } else {
        this.setState({ inlineAtBottom: this.isElAtBottom(el) });
      }
    }
  };

  scrollToContinueIfNeeded = () => {
    if (this.continueBtnRef) {
      const rect = this.continueBtnRef.getBoundingClientRect();
      const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
      if (!isVisible) {
        this.continueBtnRef.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }
  };

  // Identity consent ("I confirm I am …") only needs to be attested once per
  // session. After the first agreement it is remembered in sessionStorage so
  // subsequent agreements skip the checkbox and treat consent as given.
  isConsentConfirmed = () => {
    try {
      return sessionStorage.getItem(`authConsentConfirmed_${auth.getAccount()}`) === "1";
    } catch (e) {
      return false;
    }
  };

  // Smoothly scroll a document reading container to its bottom. This naturally
  // fires handleDocumentScroll, flipping hasReachedEndOnce → true.
  scrollAgreementToBottom = (ref) => {
    const el = ref || this.scrollContainerRef;
    if (el) {
      el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
    }
  };

  // Recompute scrollProgress from a specific reading container. Progress is
  // shared state, but the inline panel and the fullscreen overlay have
  // different heights, so it must be re-derived whenever the visible
  // container changes. hasReachedEndOnce only ever latches to true.
  recomputeScrollProgress = (el) => {
    const flagUpdate = this.getAtBottomFlagUpdate(el);
    const isFullscreenTarget = !!el && el === this.fullscreenScrollRef;
    const fullscreenReadComplete = isFullscreenTarget && this.isElAtBottom(el, 80);
    if (this.state.hasReachedEndOnce) {
      this.setState((prevState) => ({
        ...flagUpdate,
        scrollProgress: 100,
        fullscreenReadComplete: prevState.fullscreenReadComplete || prevState.hasReachedEndOnce || (isFullscreenTarget && fullscreenReadComplete),
      }));
      return;
    }
    if (!el) return;
    if (el.scrollHeight <= el.clientHeight + 5) {
      this.setState({ ...flagUpdate, scrollProgress: 100, hasReachedEndOnce: true, fullscreenReadComplete: isFullscreenTarget ? true : this.state.fullscreenReadComplete });
      return;
    }
    const progress = Math.min(
      Math.round((el.scrollTop / (el.scrollHeight - el.clientHeight)) * 100),
      100
    );
    this.setState((prevState) => ({
      ...flagUpdate,
      scrollProgress: isFullscreenTarget && fullscreenReadComplete ? 100 : progress,
      fullscreenReadComplete: prevState.fullscreenReadComplete || (isFullscreenTarget && fullscreenReadComplete),
    }));
  };

  openReadFullscreen = () => {
    // fresh open starts at the top; recompute below corrects for short docs
    this.setState({ readFullscreenOpen: true, fullscreenAtBottom: false, fullscreenReadComplete: false }, () => {
      setTimeout(() => {
        this.recomputeScrollProgress(this.fullscreenScrollRef);
        // The fullscreen copy of the agreement mounts fresh — re-apply any
        // captured signature so it is visible there too.
        this.refreshSignaturePreview();
      }, 150);
    });
  };

  closeReadFullscreen = () => {
    this.setState({ readFullscreenOpen: false, fullscreenReadComplete: false }, () => {
      setTimeout(() => this.recomputeScrollProgress(this.scrollContainerRef), 150);
    });
  };

  // Draw the user's eye to the "I confirm" consent box (scroll + pulse) when
  // they try to continue e-signing without confirming identity first.
  flashConsentAttention = () => {
    if (this.consentBoxRef) {
      this.consentBoxRef.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    this.setState({ highlightConsent: true });
    clearTimeout(this._consentHighlightTimer);
    this._consentHighlightTimer = setTimeout(() => {
      this.setState({ highlightConsent: false });
    }, 2200);
  };

  // "Continue E-Sign" from the fullscreen reader. The explicit continue click
  // counts as having read the document, so the read gate is satisfied
  // immediately — the user shouldn't have to scroll again just to proceed.
  // Then: if "I confirm" is already checked, go straight to the signature
  // step; otherwise land back on Step 1 focused on the "I confirm" checkbox,
  // which becomes the only remaining step before signing.
  continueEsignFromFullscreen = () => {
    // Continue is only available once the user has read to the end in the
    // fullscreen reader (the buttons are also styled disabled until then).
    if (!this.state.fullscreenReadComplete) {
      return;
    }
    const consentOk = this.state.consentChecked;
    this.setState({
      readFullscreenOpen: false,
      scrollProgress: 100,
      hasReachedEndOnce: true,
    }, () => {
      if (consentOk) {
        this.goToStep(2);
        // Force the signature panel into view once the overlay has unmounted
        // and the page layout has settled (esp. on mobile where the panel
        // stacks below the document).
        setTimeout(() => this.scrollToStepPanelIfNeeded(true), 350);
      } else {
        this.setState({ currentStep: 1 }, () => {
          setTimeout(() => this.flashConsentAttention(), 200);
        });
      }
    });
  };

  goToStep = (step) => {
    if (step === 2) {
      if (!this.state.hasReachedEndOnce || !this.state.consentChecked) {
        return;
      }
    }
    if (step === 1) {
      this.inlineSignatureStrokes = [];
      this.modalSignatureStrokes = [];
      if (this.signaturePad) this.signaturePad.clear();
      if (this.signaturePadModal) this.signaturePadModal.clear();
      this.updateSignaturePreviewInAgreement("");
      this.setState({
        currentStep: 1,
        signature_type: "draw",
        signatureDrawn: false,
        signatureDataUrl: "",
        uploadedSignature: "",
        signatureText: "",
        signatureModalOpen: false,
        modalCanvasEmpty: true,
      });
      return;
    }
    this.setState({ currentStep: step }, () => {
      // Entering the sign step: prefill any signature stored for this account
      // (carry-forward), e.g. after the user went Back and returned, and make
      // sure the signature panel is in view (it sits below the document on
      // small screens).
      if (step === 2) {
        setTimeout(() => {
          try {
            this.restoreSignatureFromLocalStorage();
          } catch (e) {
            // ignore
          }
          this.scrollToStepPanelIfNeeded();
        }, 150);
      }
    });
  };

  scrollToStepPanelIfNeeded = (force = false) => {
    if (this.stepPanelRef) {
      const rect = this.stepPanelRef.getBoundingClientRect();
      const isVisible = rect.top >= 0 && rect.top <= window.innerHeight * 0.5;
      if (force || !isVisible) {
        this.stepPanelRef.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  toggleCC = () => {
    this.setState((prevState) => {
      if (!prevState.ccOpen) {
        return { ccOpen: true, ccList: prevState.ccList.length === 0 ? [""] : prevState.ccList };
      }
      return { ccOpen: false };
    });
  };

  addCCField = () => {
    this.setState((prevState) => ({
      ccList: [...prevState.ccList, ""],
    }));
  };

  removeCCField = (index) => {
    this.setState((prevState) => ({
      ccList: prevState.ccList.filter((_, i) => i !== index),
      ccOpen: prevState.ccList.length <= 1 ? false : true,
    }));
  };

  handleCCChange = (index, value) => {
    this.setState((prevState) => {
      const ccList = [...prevState.ccList];
      ccList[index] = value;
      return { ccList };
    });
  };

  getSigneeEmailError = () => {
    const { signee_email } = this.state;
    if (signee_email.length === 0) return "";
    if (ValidateEmail(signee_email) === false) return "Please enter a valid email address";
    return "";
  };

  getCCEmailError = (index) => {
    const cc = this.state.ccList[index];
    if (!cc || cc.trim() === "") return "";
    if (ValidateEmail(cc) === false) return "Invalid email format";
    return "";
  };

  isSendDisabled = () => {
    const { signee_name, signee_email, signee_comment, ccList, ccOpen } = this.state;
    if (signee_name.trim() === "") return true;
    if (!this.isValidSigneeName(signee_name)) return true;
    if (signee_email.trim() === "" || ValidateEmail(signee_email) === false) return true;
    if (signee_comment.trim() === "") return true;
    if (ccOpen && ccList.length > 0) {
      for (let i = 0; i < ccList.length; i++) {
        if (ccList[i].trim() !== "" && ValidateEmail(ccList[i]) === false) return true;
      }
    }
    return false;
  };

  downloadPdf = async () => {
    const documentTitle = this.getAgreementDownloadBaseName();
    this.setState({ downloading: true, downloadingFormat: "PDF" });
    try {
      const contentDivId = "agreement_content_id_" + this.state.agreement_accountno;
      const contentDiv = document.getElementById(contentDivId);
      if (!contentDiv) {
        this.setState({ downloading: false, downloadingFormat: "" });
        return;
      }
      const response = await downloadAgreementPdf(
        auth.getAccount(),
        auth.getToken(),
        contentDiv.innerHTML,
        this.state.agreement_title || documentTitle
      );
      if (response && response.data) {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
        const a = document.createElement("a");
        a.href = url;
        a.download = documentTitle + ".pdf";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("PDF download error:", error);
    } finally {
      this.setState({ downloading: false, downloadingFormat: "" });
    }
  };

  downloadTxt = () => {
    const activeTabPane = document.querySelector(".tab-pane.active");
    if (!activeTabPane) return;
    const documentTitle = this.getAgreementDownloadBaseName();
    this.setState({ downloading: true, downloadingFormat: "TXT" });
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = activeTabPane.innerHTML || "";
    const sigBlock = Array.from(tempDiv.querySelectorAll("div")).find(
      el => (el.getAttribute("style") || "").includes("background:#fdf8ee")
    );
    if (sigBlock) {
      const flexDiv = sigBlock.firstElementChild;
      const parts = [
        "<p>============================================</p>",
        "<p>SIGNATURES</p>",
        "<p>============================================</p>",
      ];
      if (flexDiv) {
        Array.from(flexDiv.children).forEach(card => {
          const headerDiv = card.firstElementChild;
          const contentDiv = card.children[1];
          const headerSpans = headerDiv ? Array.from(headerDiv.querySelectorAll("span")) : [];
          const sectionLabel = headerSpans.map(s => s.textContent.trim()).filter(Boolean).join(" - ");
          if (sectionLabel) parts.push("<p>&nbsp;</p><p><b>" + sectionLabel.toUpperCase() + "</b></p>");
          if (contentDiv) {
            const nameDiv = contentDiv.firstElementChild;
            if (nameDiv && nameDiv.textContent.trim()) {
              parts.push("<p>Organization: " + nameDiv.textContent.trim() + "</p>");
            }
            const fieldContainer = Array.from(contentDiv.children).find(
              el => (el.getAttribute("style") || "").includes("flex-direction:column")
            );
            if (fieldContainer) {
              Array.from(fieldContainer.children).forEach(row => {
                const spans = Array.from(row.querySelectorAll("span"));
                if (spans.length >= 2) {
                  const label = spans[0].textContent.trim();
                  const value = spans[1].textContent.trim();
                  if (label) parts.push("<p>" + label + ": " + value + "</p>");
                }
              });
            }
          }
        });
      }
      parts.push("<p>&nbsp;</p><p>============================================</p>");
      const replacer = document.createElement("div");
      replacer.innerHTML = parts.join("");
      sigBlock.parentNode.replaceChild(replacer, sigBlock);
    }
    const content = tempDiv.innerHTML;
    const cleanedHtml = content
      .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "")
      .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, "")
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/<\/p>/gi, "\n\n")
      .replace(/<[^>]+>/g, "");
    const decoder = document.createElement("textarea");
    decoder.innerHTML = cleanedHtml;
    const text = decoder.value
      .replace(/\u00A0/g, " ")
      .replace(/[\u200B-\u200D\uFEFF]/g, "")
      .replace(/\r\n/g, "\n")
      .replace(/\n{3,}/g, "\n\n")
      .trim();
    const blob = new Blob([text], { type: "text/plain" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = documentTitle + ".txt";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    this.setState({ downloading: false, downloadingFormat: "" });
  };

  renderIcon(name, size = 14, color = "currentColor", style = {}) {
    const icons = {
      "check": <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" style={style}><polyline points="20 6 9 17 4 12"/></svg>,
      "cross": <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={style}><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
      "send": <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={style}><path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4 20-7z"/></svg>,
      "info": <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={style}><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>,
      "alert": <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={style}><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>,
      "arrow-left": <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={style}><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>,
      "plus": <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={style}><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
      "check-circle": <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={style}><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>,
      "edit": <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={style}><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4z"/></svg>,
      "undo": <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={style}><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 100-9.49"/></svg>,
      "lock": <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={style}><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>,
      "download": <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={style}><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>,
      "file-pdf": <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={style}><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M9 13h2M9 17h6"/></svg>,
      "file-doc": <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={style}><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
      "file-text": <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={style}><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>,
    };
    return icons[name] || null;
  }

  renderStepPanel = () => {
    const { currentStep, scrollProgress, agreement_type } = this.state;
    return (
      <div ref={(el) => { this.stepPanelRef = el; }} style={{ background: "#fff", border: "1px solid #e5e9f2", borderRadius: "12px", height: "100%", display: "flex", flexDirection: "column" }}>
        <div style={{ padding: "24px", flex: 1, display: "flex", flexDirection: "column" }}>
          {currentStep === 1 ? (
            /* STEP 1: Review & Verify */
            <div>
              {/* Step Header with pill badge */}
              <div style={{ marginBottom: "20px" }}>
                <div style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: `${THEME_COLOR}0f`, border: `1px solid ${THEME_COLOR}30`, borderRadius: "999px", padding: "4px 11px", marginBottom: "10px" }}>
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke={THEME_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                  <span style={{ fontSize: "10px", fontWeight: "700", color: THEME_COLOR }}>Step 1 of 2</span>
                </div>
                <h5 style={{ fontWeight: "700", color: "#364a63", marginBottom: "4px", fontSize: "16px" }}>
                  Review &amp; verify
                </h5>
                <p style={{ fontSize: "12px", color: "#8094ae", margin: 0 }}>Confirm the parties and read the document</p>
              </div>
              <hr style={{ margin: "0 0 16px 0", border: "none", borderTop: "1px solid #e5e9f2" }} />

              {/* Parties label */}
              <div style={{ fontSize: "9px", fontWeight: "700", letterSpacing: "0.1em", textTransform: "uppercase", color: "#8094ae", marginBottom: "8px" }}>Parties</div>

              {/* Disclosing Party (Vendor) */}
              {this.state.vendorData.length > 0 && (
                <div style={{ background: "#f8f9fa", border: "1px solid #e5e9f2", borderRadius: "10px", padding: "12px 14px", marginBottom: "8px" }}>
                  <div style={{ fontSize: "9px", fontWeight: "700", letterSpacing: "0.09em", textTransform: "uppercase", color: "#8094ae", marginBottom: "8px" }}>Disclosing Party</div>
                  <div style={{ fontSize: "14px", fontWeight: "700", color: "#364a63", marginBottom: "8px" }}>
                    {this.state.vendorData[0].reseller_comp}
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                    {this.state.vendorData[0].reseller_address && (
                      <div style={{ display: "flex", alignItems: "center", gap: "7px", fontSize: "11px", color: "#526484" }}>
                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#8094ae" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                        {`${this.state.vendorData[0].reseller_address}, ${this.state.vendorData[0].reseller_city}, ${this.state.vendorData[0].reseller_state} ${this.state.vendorData[0].reseller_zip}`}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Receiving Party - Signing Now (Client) */}
              {this.state.resellerUserData.length > 0 && (
                <div style={{ background: "#f8f9fa", border: "1px solid #e5e9f2", borderRadius: "10px", padding: "12px 14px", marginBottom: "8px" }}>
                  <div style={{ fontSize: "9px", fontWeight: "700", letterSpacing: "0.09em", textTransform: "uppercase", color: "#8094ae", marginBottom: "8px" }}>Receiving Party - Signing Now</div>
                  <div style={{ fontSize: "14px", fontWeight: "700", color: "#364a63", marginBottom: "8px" }}>
                    {this.state.resellerUserData[0]["name"]}
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "7px", fontSize: "11px", color: "#526484" }}>
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#8094ae" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
                      {this.state.resellerUserData[0]["comp_name"]}
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "7px", fontSize: "11px", color: "#526484" }}>
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#8094ae" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                      {this.state.resellerUserData[0]["email"]}
                    </div>
                  </div>
                </div>
              )}

              {/* Consent Checkbox — shown only the first time; once attested it
                  is remembered for the session and later agreements skip it. */}
              {!this.isConsentConfirmed() ? (
                <div
                  ref={(el) => { this.consentBoxRef = el; }}
                  className={this.state.highlightConsent ? "agr-consent-attention" : ""}
                  style={{
                    border: this.state.consentChecked ? `1.5px solid ${THEME_COLOR}` : "1.5px solid #e5e9f2",
                    borderRadius: "10px",
                    padding: "12px 13px",
                    marginBottom: "12px",
                    backgroundColor: this.state.consentChecked ? `${THEME_COLOR}08` : "#fff",
                    transition: "all 0.2s ease",
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (this.state.consentChecked) return;
                    this.setState({ consentChecked: true }, () => {
                      this.scrollToContinueIfNeeded();
                      try { sessionStorage.setItem(`authConsentConfirmed_${auth.getAccount()}`, "1"); } catch(e) {}
                    });
                  }}
                >
                  <div
                    style={{
                      width: "18px", height: "18px", borderRadius: "5px",
                      border: this.state.consentChecked ? `2px solid ${THEME_COLOR}` : "2px solid #c4cdd5",
                      backgroundColor: this.state.consentChecked ? THEME_COLOR : "#fff",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      flexShrink: 0, marginTop: "1px", transition: "all 0.15s ease",
                    }}
                  >
                    {this.state.consentChecked && (
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                    )}
                  </div>
                  <div style={{ fontSize: "11px", lineHeight: "1.55", color: "#526484" }}>
                    I confirm I am{" "}
                    <strong style={{ color: "#364a63" }}>
                      {this.state.resellerUserData.length > 0 ? this.state.resellerUserData[0]["name"] : "the authorized signee"}
                    </strong>
                    , authorised to sign on behalf of my organisation, and agree to sign electronically with the same legal effect as a handwritten signature.
                  </div>
                </div>
              ) : null}

              {/* Scroll warning */}
              {!this.state.hasReachedEndOnce && (
                <div style={{ background: "#FFF8E1", border: "1px solid #FFD54F", borderRadius: "8px", padding: "9px 12px", display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px", fontSize: "11px", color: "#8D6E63" }}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#F59E0B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                  Please scroll through the entire agreement to continue.{" "}
                  <strong>{scrollProgress}% read</strong>
                </div>
              )}

              {/* Footer — on mobile the inline Continue hides (sticky bar takes over) */}
              <div className="agr-panel-footer" style={{ borderTop: "1px solid #e5e9f2", paddingTop: "12px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "11px", color: "#8094ae" }}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
                  Verified via secure link
                </div>
                <button
                  className="btn btn-sm agr-panel-continue-btn"
                  ref={(el) => { this.continueBtnRef = el; }}
                  style={{
                    display: "inline-flex", alignItems: "center", gap: "6px", padding: "8px 18px", borderRadius: "8px",
                    backgroundColor: this.state.hasReachedEndOnce && this.state.consentChecked ? THEME_COLOR : "#c4cdd5",
                    color: this.state.hasReachedEndOnce && this.state.consentChecked ? THEME_TEXT_COLOR : "#fff",
                    cursor: this.state.hasReachedEndOnce && this.state.consentChecked ? "pointer" : "not-allowed",
                    fontSize: "12px", fontWeight: "600", border: "none", transition: "all 0.2s ease",
                  }}
                  onClick={() => this.goToStep(2)}
                  disabled={!this.state.hasReachedEndOnce || !this.state.consentChecked}
                >
                  Continue
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
                </button>
              </div>
            </div>
          ) : (
            /* STEP 2: Sign & Submit */
            <div>
              {/* Step 2 Header with pill badge */}
              <div style={{ marginBottom: "20px" }}>
                <div style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: `${THEME_COLOR}0f`, border: `1px solid ${THEME_COLOR}30`, borderRadius: "999px", padding: "4px 11px", marginBottom: "10px" }}>
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke={THEME_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4z"/></svg>
                  <span style={{ fontSize: "10px", fontWeight: "700", color: THEME_COLOR }}>Step 2 of 2</span>
                </div>
                <h5 style={{ fontWeight: "700", color: "#364a63", marginBottom: "4px", fontSize: "16px" }}>
                  {agreement_type === "accept" ? <>Accept this <em style={{ fontStyle: "italic" }}>agreement</em></> : <>Add your <em style={{ fontStyle: "italic" }}>signature</em></>}
                </h5>
                {agreement_type !== "accept" && (
                  <p style={{ fontSize: "12px", color: "#8094ae", margin: 0 }}>Choose how you'd like to sign</p>
                )}
              </div>

              {/* E-SIGN TYPE */}
              {agreement_type === "esign" ? (
                <>
                  <div id="signature_div" style={{ width: "100%", float: "none" }}>
                    {/* Method Selector Cards */}
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "6px", marginBottom: "16px" }}>
                      {/* Draw Card */}
                      <div
                        onClick={() => this.updateSignatureType("draw")}
                        style={{
                          padding: "10px 6px", borderRadius: "8px", cursor: "pointer", textAlign: "center", transition: "all 0.15s",
                          border: this.state.signature_type === "draw" || this.state.signature_type === "" ? `1.5px solid ${THEME_COLOR}` : "1.5px solid #e5e9f2",
                          backgroundColor: this.state.signature_type === "draw" || this.state.signature_type === "" ? `${THEME_COLOR}0a` : "#fff",
                        }}
                      >
                        <div style={{ width: "28px", height: "28px", borderRadius: "7px", background: this.state.signature_type === "draw" || this.state.signature_type === "" ? `${THEME_COLOR}15` : "#f5f6fa", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 6px" }}>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={this.state.signature_type === "draw" || this.state.signature_type === "" ? THEME_COLOR : "#8094ae"} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4z"/></svg>
                        </div>
                        <span style={{ fontSize: "11px", fontWeight: "600", color: this.state.signature_type === "draw" || this.state.signature_type === "" ? THEME_COLOR : "#526484" }}>Draw</span>
                      </div>
                      {/* Choose Style Card */}
                      <div
                        onClick={() => this.updateSignatureType("choose")}
                        style={{
                          padding: "10px 6px", borderRadius: "8px", cursor: "pointer", textAlign: "center", transition: "all 0.15s",
                          border: this.state.signature_type === "choose" ? `1.5px solid ${THEME_COLOR}` : "1.5px solid #e5e9f2",
                          backgroundColor: this.state.signature_type === "choose" ? `${THEME_COLOR}0a` : "#fff",
                        }}
                      >
                        <div style={{ width: "28px", height: "28px", borderRadius: "7px", background: this.state.signature_type === "choose" ? `${THEME_COLOR}15` : "#f5f6fa", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 6px" }}>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={this.state.signature_type === "choose" ? THEME_COLOR : "#8094ae"} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><polyline points="4 7 4 4 20 4 20 7"/><line x1="9" y1="20" x2="15" y2="20"/><line x1="12" y1="4" x2="12" y2="20"/></svg>
                        </div>
                        <span style={{ fontSize: "11px", fontWeight: "600", color: this.state.signature_type === "choose" ? THEME_COLOR : "#526484" }}>Type Name</span>
                      </div>
                      {/* Copy Link Card */}
                      <div
                        onClick={() => !this.state.copyLinkLoading && this.copySigneeLink()}
                        style={{
                          padding: "10px 6px", borderRadius: "8px", cursor: "pointer", textAlign: "center", transition: "all 0.15s",
                          border: this.state.copied ? `1.5px solid ${THEME_COLOR}` : "1.5px solid #e5e9f2",
                          backgroundColor: this.state.copied ? `${THEME_COLOR}0a` : "#fff",
                        }}
                      >
                        <div style={{ width: "28px", height: "28px", borderRadius: "7px", background: this.state.copied ? `${THEME_COLOR}15` : "#f5f6fa", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 6px" }}>
                          {this.state.copyLinkLoading ? (
                            <span className="spinner-border spinner-border-sm" style={{ width: "12px", height: "12px", color: "#8094ae" }} role="status" aria-hidden="true"></span>
                          ) : (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={this.state.copied ? THEME_COLOR : "#8094ae"} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>
                          )}
                        </div>
                        <span style={{ fontSize: "11px", fontWeight: "600", color: this.state.copied ? THEME_COLOR : "#526484" }}>{this.state.copied ? "Copied!" : "Copy Link"}</span>
                      </div>
                      {/* Upload Image Card */}
                      <div
                        onClick={() => this.updateSignatureType("upload")}
                        style={{
                          padding: "10px 6px", borderRadius: "8px", cursor: "pointer", textAlign: "center", transition: "all 0.15s",
                          border: this.state.signature_type === "upload" ? `1.5px solid ${THEME_COLOR}` : "1.5px solid #e5e9f2",
                          backgroundColor: this.state.signature_type === "upload" ? `${THEME_COLOR}0a` : "#fff",
                        }}
                      >
                        <div style={{ width: "28px", height: "28px", borderRadius: "7px", background: this.state.signature_type === "upload" ? `${THEME_COLOR}15` : "#f5f6fa", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 6px" }}>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={this.state.signature_type === "upload" ? THEME_COLOR : "#8094ae"} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>
                        </div>
                        <span style={{ fontSize: "11px", fontWeight: "600", color: this.state.signature_type === "upload" ? THEME_COLOR : "#526484" }}>Upload image</span>
                      </div>
                      {/* Send to Signee Card - spans 2 columns */}
                      <div
                        onClick={() => this.updateSignatureType("signee")}
                        style={{
                          gridColumn: "span 2", padding: "10px 6px", borderRadius: "8px", cursor: "pointer", textAlign: "center", transition: "all 0.15s",
                          border: this.state.signature_type === "signee" ? `1.5px solid ${THEME_COLOR}` : "1.5px solid #e5e9f2",
                          backgroundColor: this.state.signature_type === "signee" ? `${THEME_COLOR}0a` : "#fff",
                        }}
                      >
                        <div style={{ width: "28px", height: "28px", borderRadius: "7px", background: this.state.signature_type === "signee" ? `${THEME_COLOR}15` : "#f5f6fa", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 6px" }}>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={this.state.signature_type === "signee" ? THEME_COLOR : "#8094ae"} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><path d="M22 2L11 13"/><path d="M22 2l-7 20-4-9-9-4 20-7z"/></svg>
                        </div>
                        <span style={{ fontSize: "11px", fontWeight: "600", color: this.state.signature_type === "signee" ? THEME_COLOR : "#526484" }}>Send to Signee</span>
                      </div>
                    </div>

                    {/* Signature Area */}
                    <div className="tab-content">
                      {/* Choose Style Pane */}
                      <div className={this.state.signature_type === "choose" ? "tab-pane active" : "tab-pane"} id="tabItem5">
                        <div className="form-group mb-3">
                          <MutextField required id="signatureText" name="signatureText" type="text" label="Authorized Person Name" inputProps={{ maxLength: 30 }} onInput={(e) => { e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/gi, ""); }} value={this.state.signatureText} onChange={this.handleChange} helperText="" variant="outlined" fullWidth autoComplete="new-password" />
                        </div>
                        <h6 style={{ fontSize: "12px", fontWeight: "600", color: "#8094ae", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "10px" }}>Type Name</h6>
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginBottom: "16px" }}>
                          {[{ name: "Dancing Script", label: "Handwritten", value: "'Dancing Script', cursive" }, { name: "Caveat", label: "Cursive", value: "'Caveat', cursive" }, { name: "Sacramento", label: "Classic", value: "'Sacramento', cursive" }].map((font, index) => (
                            <div key={index} onClick={() => this.handleSignature(font.value)} style={{ padding: "14px 16px", borderRadius: "8px", border: this.state.signatureClass === font.value ? `2px solid ${THEME_COLOR}` : "2px solid transparent", backgroundColor: this.state.signatureClass === font.value ? `${THEME_COLOR}08` : "#fff", cursor: "pointer", transition: "all 0.2s ease", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                              <span style={{ fontFamily: font.value, fontSize: "24px", color: "#364a63" }}>{this.state.signatureText || "Your Signature"}</span>
                              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <span style={{ fontSize: "11px", fontWeight: "600", color: this.state.signatureClass === font.value ? THEME_COLOR : "#8094ae", textTransform: "uppercase", letterSpacing: "0.5px" }}>{font.label}</span>
                                {this.state.signatureClass === font.value && (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={THEME_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>)}
                              </div>
                            </div>
                          ))}
                        </div>
                        {/* <div className="signature-preview mt-3" id="styled-text-container" style={{ fontFamily: this.state.signatureClass, fontSize: "32px", width: "100%", maxWidth: "480px", height: "80px", background: "transparent", backgroundColor: "transparent", border: "none", lineHeight: "80px", color: "#000" }}>
                          {this.state.signatureText || "Your Signature"}
                        </div> */}
                        <div id="styled-text-container" style={{ fontFamily: this.state.signatureClass, fontSize: "32px", width: "100%", maxWidth: "480px", height: "80px", background: "transparent", backgroundColor: "transparent", border: "none", lineHeight: "80px", color: "#000", overflow: "hidden", position: "fixed", top: "-9999px", left: "0px" }}>
                          {this.state.signatureText || "Your Signature"}
                        </div>
                      </div>

                      {/* Draw Pane */}
                      <div className={this.state.signature_type === "draw" || this.state.signature_type === "" ? "tab-pane active" : "tab-pane"} id="tabItem6">
                        <Row>
                          <Col sm={12}>
                            <div id="divSig" style={{ display: "none" }}>
                              <div className="mb-4"><img src="" className="clsimgSig" height="100" width="200" onError={(e) => (e.target.style.display = "none")} /></div>
                            </div>
                            <div><strong>Signature</strong></div>
                          </Col>
                        </Row>
                        <Row style={{ marginTop: "1%" }}>
                          <Col sm={12} style={{ position: "relative" }}>
                            <div style={{ position: "relative", border: "2px dashed #dbdfea", borderRadius: "8px", overflow: "hidden", backgroundColor: "#fafafa" }}>
                              {/* Zoom/Expand button */}
                              <button
                                type="button"
                                style={{ position: "absolute", top: "6px", right: "6px", zIndex: 2, borderRadius: "4px", width: "28px", height: "28px", padding: 0, display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#fff", border: "1px solid #dbdfea", cursor: "pointer", color: "#526484" }}
                                onClick={() => this.openSignatureModal()}
                                title="Sign in full screen"
                              >
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 3H5a2 2 0 00-2 2v3"/><path d="M21 8V5a2 2 0 00-2-2h-3"/><path d="M3 16v3a2 2 0 002 2h3"/><path d="M16 21h3a2 2 0 002-2v-3"/></svg>
                              </button>
                              <div style={{ height: "120px", position: "relative" }}>
                                <SignatureCanvas
                                  key={this.state.drawPadKey}
                                  clearOnResize={false}
                                  penColor={this.state.signatureColor}
                                  minWidth={this.state.penWidth}
                                  maxWidth={this.state.penWidth + 0.5}
                                  canvasProps={{
                                    style: {
                                      width: "100%",
                                      height: "100%",
                                      display: this.state.signatureDataUrl ? "none" : "block",
                                    },
                                  }}
                                  velocityFilterWeight={0.7}
                                  throttle={50}
                                  onBegin={this.handleInlineSignatureBegin}
                                  onEnd={this.handleInlineSignatureEnd}
                                  ref={(ref) => {
                                    this.signaturePad = ref;
                                    if (ref) {
                                      // Only resize when the pad is empty so we never wipe an
                                      // in-progress drawing on an unrelated re-render. Resizing
                                      // reassigns canvas.width which clears the canvas.
                                      setTimeout(() => {
                                        if (this.signaturePad === ref && (!ref.isEmpty || ref.isEmpty())) {
                                          this.resizeSignatureCanvas(ref, 120);
                                        }
                                      }, 0);
                                    }
                                  }}
                                />
                                {/* Modal signature preview overlay */}
                                {this.state.signatureDataUrl && (
                                  <img
                                    src={this.state.signatureDataUrl}
                                    alt="Signature"
                                    style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "contain", objectPosition: "center", padding: "8px" }}
                                  />
                                )}
                                {/* Placeholder text */}
                                {!this.state.signatureDrawn && !this.state.signatureDataUrl && (
                                  <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", textAlign: "center", pointerEvents: "none", color: "#adb5bd" }}>
                                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" style={{ display: "block", margin: "0 auto 4px" }}><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4z"/></svg>
                                    <span style={{ fontSize: "12px" }}>Draw your signature here</span>
                                  </div>
                                )}
                                {/* Baseline guide */}
                                <div style={{ position: "absolute", bottom: "20px", left: "10%", right: "10%", height: "1px", backgroundColor: "#dbdfea", pointerEvents: "none" }} />
                              </div>
                              {/* Draw tools: sizes + divider + ink colors + clear */}
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 10px", background: "#f8f9fc", border: "1px solid #e5e9f2", borderTop: "none", borderRadius: "0 0 10px 10px" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                  {/* Pen sizes */}
                                  {this.penSizes.map((s, idx) => (
                                    <button
                                      key={idx}
                                      type="button"
                                      title={s.label}
                                      onClick={() => this.setState({ penWidth: s.penWidth })}
                                      style={{
                                        width: "24px", height: "24px", borderRadius: "50%",
                                        background: this.state.penWidth === s.penWidth ? "rgba(15,58,112,0.08)" : "#fff",
                                        border: this.state.penWidth === s.penWidth ? "1.5px solid #0F3A70" : "1.5px solid #e5e9f2",
                                        cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
                                        padding: 0, transition: "all 0.13s",
                                      }}
                                    >
                                      <div style={{ width: s.dotSize + "px", height: s.dotSize + "px", borderRadius: "50%", background: "#526484" }} />
                                    </button>
                                  ))}
                                  {/* Divider */}
                                  <div style={{ width: "1px", height: "16px", backgroundColor: "#e5e9f2" }} />
                                  {/* Ink colors */}
                                  {this.inkColors.map((c, idx) => (
                                    <div
                                      key={idx}
                                      onClick={() => this.setState({ signatureColor: c.value })}
                                      title={c.name}
                                      style={{
                                        width: "18px", height: "18px", borderRadius: "50%",
                                        backgroundColor: c.value, cursor: "pointer",
                                        border: this.state.signatureColor === c.value ? "2px solid #526484" : "2px solid transparent",
                                        boxShadow: this.state.signatureColor === c.value ? "0 0 0 2px white" : "none",
                                        transition: "all 0.13s",
                                      }}
                                    />
                                  ))}
                                </div>
                                <button
                                  type="button"
                                  style={{ fontFamily: "inherit", fontSize: "11px", fontWeight: "600", color: "#e85347", background: "transparent", border: "1px solid rgba(176,42,42,0.25)", borderRadius: "7px", padding: "4px 9px", cursor: "pointer", display: "flex", alignItems: "center", gap: "4px", transition: "all 0.13s" }}
                                  onClick={() => this.clear()}
                                >
                                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#e85347" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="1 4 1 10 7 10"/><path d="M3.51 15a9 9 0 100-9.49"/></svg> Clear
                                </button>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>

                      {/* Upload Pane */}
                      <div className={this.state.signature_type === "upload" ? "tab-pane active" : "tab-pane"} id="tabItemUpload">
                        <div
                          style={{ border: "2px dashed #dbdfea", borderRadius: "8px", padding: "30px 20px", textAlign: "center", backgroundColor: "#f8f9fc", cursor: "pointer", transition: "all 0.2s ease", position: "relative" }}
                          onClick={() => { document.getElementById("signatureUploadInput").click(); }}
                          onDragOver={(e) => { e.preventDefault(); e.currentTarget.style.borderColor = THEME_COLOR; e.currentTarget.style.backgroundColor = `${THEME_COLOR}08`; }}
                          onDragLeave={(e) => { e.currentTarget.style.borderColor = "#dbdfea"; e.currentTarget.style.backgroundColor = "#f8f9fc"; }}
                          onDrop={(e) => { e.preventDefault(); e.currentTarget.style.borderColor = "#dbdfea"; e.currentTarget.style.backgroundColor = "#f8f9fc"; if (e.dataTransfer.files && e.dataTransfer.files[0]) { this.handleSignatureUpload({ target: { files: e.dataTransfer.files } }); } }}
                        >
                          <input type="file" id="signatureUploadInput" accept="image/png,image/jpeg,image/jpg" style={{ display: "none" }} onChange={this.handleSignatureUpload} />
                          {this.state.uploadedSignature ? (
                            <div>
                              <img src={this.state.uploadedSignature} alt="Uploaded Signature" style={{ maxWidth: "100%", maxHeight: "120px", marginBottom: "12px", border: "1px solid #e5e9f2", borderRadius: "4px", padding: "8px", backgroundColor: "#fff" }} />
                              <div>
                                <button className="btn btn-sm btn-outline-danger" onClick={this.clearUploadedSignature} style={{ marginTop: "8px", display: "inline-flex", alignItems: "center", gap: "6px", padding: "6px 12px" }}>
                                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>
                                  <span>Remove</span>
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div>
                              <div style={{ width: "36px", height: "36px", borderRadius: "50%", background: "#e5e9f2", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 8px" }}><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8094ae" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></div>
                              <p style={{ fontSize: "13px", fontWeight: "600", color: "#364a63", marginBottom: "4px" }}>Click to upload or drag &amp; drop</p>
                              <p style={{ fontSize: "12px", color: "#8094ae", margin: 0 }}>PNG or JPG (max 2MB)</p>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Type Name Pane */}
                      <div className={this.state.signature_type === "type" ? "tab-pane active" : "tab-pane"} id="tabItemType">
                        <div className="form-group mb-3">
                          <MutextField required id="signatureText" name="signatureText" type="text" label="Type your full name" inputProps={{ maxLength: 30 }} onInput={(e) => { e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/gi, ""); }} value={this.state.signatureText} onChange={this.handleChange} helperText="" variant="outlined" fullWidth autoComplete="new-password" />
                        </div>
                        <div style={{ border: "2px dashed #dbdfea", borderRadius: "8px", padding: "20px", textAlign: "center", backgroundColor: "#fafafa", minHeight: "80px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                          {this.renderIcon("edit", 20, "#8094ae")}
                          <span style={{ fontFamily: "'Dancing Script', cursive", fontSize: "32px", color: "#364a63" }}>{this.state.signatureText || "Your Name"}</span>
                        </div>
                        <div
                          id="typed-text-container"
                          style={{
                            fontFamily: "'Dancing Script', cursive",
                            fontSize: "32px",
                            width: "100%",
                            maxWidth: "480px",
                            height: "80px",
                            background: "transparent",
                            backgroundColor: "transparent",
                            border: "none",
                            lineHeight: "80px",
                            color: "#000",
                            overflow: "hidden",
                            position: "fixed",
                            top: "-9999px",
                            left: "0px",
                          }}
                        >
                          {this.state.signatureText || "Your Name"}
                        </div>
                      </div>

                      {/* Send to Signee Pane */}
                      <div className={this.state.signature_type === "signee" ? "tab-pane active" : "tab-pane"} id="tabItemSignee">
                        <h6 style={{ marginBottom: "12px" }}>Send To Signee</h6>
                        {this.state.errorMessageSignee !== "" ? (
                          <div className="example-alert" style={{ marginBottom: "10px" }}>
                            <div className="alert alert-pro alert-danger">
                              <div className="alert-text">
                                <h4>Error</h4>
                                <p>{this.state.errorMessageSignee}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {this.state.successMessageSignee !== "" ? (
                          <div className="example-alert" style={{ marginBottom: "10px" }}>
                            <div className="alert alert-pro alert-success">
                              <div className="alert-text">
                                <h4>Success</h4>
                                <p>{this.state.successMessageSignee}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        <div className="alert alert-info alert-icon" style={{ marginBottom: "15px", display: "flex", alignItems: "flex-start", gap: "10px" }}>
                          {this.renderIcon("info", 16, "currentColor", { flexShrink: 0, marginTop: "1px" })}
                          <span>A secure tokenized signing link will be emailed to the signee. They can sign without logging in.</span>
                        </div>
                        <div className="row g-4">
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label style={{ fontWeight: "500", fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.5px", color: "#8094ae", display: "block", marginBottom: "6px" }}>Full Name <span style={{ color: "#e85347" }}>*</span></label>
                              <MutextField required id="signee_name" name="signee_name" type="text" placeholder="Full Name" value={this.state.signee_name} onChange={this.handleChange} variant="outlined" fullWidth autoComplete="new-password" inputProps={{ maxLength: 30 }} error={(this.state.signee_name.length > 0 && !this.isValidSigneeName(this.state.signee_name)) || this.state.signee_name.length >= 30} helperText={(this.state.signee_name.length > 0 && !this.isValidSigneeName(this.state.signee_name)) ? "Name can include only letters, spaces, apostrophes, periods, and hyphens" : (this.state.signee_name.length >= 30 ? "Maximum 30 characters allowed" : "")} />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label style={{ fontWeight: "500", fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.5px", color: "#8094ae", display: "block", marginBottom: "6px" }}>Title</label>
                              <MutextField id="signee_title" name="signee_title" type="text" placeholder="Title" value={this.state.signee_title} onChange={this.handleChange} variant="outlined" fullWidth autoComplete="new-password" inputProps={{ maxLength: 30 }} error={this.state.signee_title.length >= 30} helperText={this.state.signee_title.length >= 30 ? "Maximum 30 characters allowed" : ""} />
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="form-group">
                              <label style={{ fontWeight: "500", fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.5px", color: "#8094ae", display: "block", marginBottom: "6px" }}>Email Address <span style={{ color: "#e85347" }}>*</span></label>
                              <MutextField required id="signee_email" name="signee_email" type="text" placeholder="Email Address" value={this.state.signee_email} onChange={this.handleChange} variant="outlined" fullWidth autoComplete="new-password" error={this.getSigneeEmailError() !== ""} helperText={this.getSigneeEmailError()} />
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="form-group">
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
                                <span style={{ fontWeight: "500", fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.5px", color: "#8094ae" }}>CC (Carbon Copy)</span>
                                <span
                                  style={{ cursor: "pointer", color: this.state.ccOpen ? "#e85347" : "#364a63", fontSize: "13px", fontWeight: "500", display: "flex", alignItems: "center", gap: "4px" }}
                                  onClick={() => this.toggleCC()}
                                >
                                  <em className={`icon ni ${this.state.ccOpen ? "ni-minus" : "ni-plus"}`} style={{ fontSize: "12px" }}></em>
                                  {this.state.ccOpen ? "Remove All" : "Add CC"}
                                </span>
                              </div>
                              {this.state.ccOpen && this.state.ccList.map((cc, index) => (
                                <div key={index} style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "10px" }}>
                                  <div style={{ flex: 1, minWidth: 0 }}>
                                    <MutextField id={`cc_email_${index}`} name={`cc_email_${index}`} type="text" label={`CC Email ${index + 1}`} value={cc} onChange={(e) => this.handleCCChange(index, e.target.value)} variant="outlined" fullWidth autoComplete="new-password" error={this.getCCEmailError(index) !== ""} helperText={this.getCCEmailError(index)} />
                                  </div>
                                  <div style={{ display: "flex", alignItems: "center", gap: "4px", flexShrink: 0 }}>
                                    <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => this.removeCCField(index)} title="Remove"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg></button>
                                    {index === this.state.ccList.length - 1 && (
                                      <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => this.addCCField()} title="Add Another">{this.renderIcon("plus")}</button>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="form-group">
                              <textarea className="form-control" id="signee_comment" name="signee_comment" onChange={this.handleChangeTextArea} placeholder="Comments *" maxLength={1000}>{this.state.signee_comment}</textarea>
                              <div className="form-note">{this.state.signee_comment.length}/{this.state.charLimit} characters</div>
                              {this.state.characterExceededMessage && this.state.characterExceededMessage !== "" ? (
                                <div className="form-note"><code>{this.state.characterExceededMessage}</code></div>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="alert alert-warning alert-icon">
                              {this.renderIcon("alert")}{" "}
                              <strong>NOTE</strong>. This will send new agreement sign request. Your previous request will be discarded if you have sent any.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Footer */}
                    <div className="signature-action-footer" style={{ padding: "14px 18px", borderTop: "1px solid #e5e9f2" }}>
                      <div className="d-flex align-items-center signature-action-legal" style={{ gap: "6px", fontSize: "11px", color: "#8094ae", marginBottom: "10px", flexWrap: "nowrap" }}>
                        {this.renderIcon("lock", 14, "currentColor")}
                        <span>Legally binding &bull; 256-bit encrypted</span>
                      </div>
                      <div className="d-flex signature-action-buttons" style={{ gap: "8px", justifyContent: "flex-end" }}>
                        <button className="signature-action-btn" onClick={() => this.goToStep(1)} disabled={this.state.signature_type === "signee" && this.state.disabled} style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "9px 16px", borderRadius: "8px", fontSize: "13px", fontWeight: 600, cursor: this.state.signature_type === "signee" && this.state.disabled ? "not-allowed" : "pointer", background: "#fff", color: "#526484", border: "1px solid #e5e9f2", transition: "all 0.15s", opacity: this.state.signature_type === "signee" && this.state.disabled ? 0.45 : 1 }}>
                          Back
                        </button>
                        {this.state.signature_type === "signee" ? (
                          this.state.disabled ? (
                            <button className="signature-action-btn" style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "9px 16px", borderRadius: "8px", fontSize: "13px", fontWeight: 600, border: "none", background: THEME_COLOR, color: THEME_TEXT_COLOR, opacity: 0.45, cursor: "not-allowed" }} disabled>
                              <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                              <span>Sending...</span>
                            </button>
                          ) : (
                            <button className="signature-action-btn" style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "9px 16px", borderRadius: "8px", fontSize: "13px", fontWeight: 600, cursor: "pointer", border: "none", background: THEME_COLOR, color: THEME_TEXT_COLOR, transition: "all 0.15s" }} onClick={() => this.send_to_signee()} disabled={this.isSendDisabled()}>
                              {this.renderIcon("send", 13, "currentColor")}
                              Send to Signee
                            </button>
                          )
                        ) : this.state.button_submit_loader || this.state.loadingButton ? (
                          <button className="signature-action-btn" type="button" style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "9px 16px", borderRadius: "8px", fontSize: "13px", fontWeight: 600, background: THEME_COLOR, color: THEME_TEXT_COLOR, border: "none", opacity: 0.45, cursor: "not-allowed" }} disabled>
                            <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span><span>Wait...</span>
                          </button>
                        ) : (
                          <button className="signature-action-btn" style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "9px 16px", borderRadius: "8px", fontSize: "13px", fontWeight: 600, cursor: "pointer", border: "none", background: THEME_COLOR, color: THEME_TEXT_COLOR, transition: "all 0.15s" }} onClick={() => this.save()} disabled={this.isSaveDisabled()} id="save_btn">
                            {this.renderIcon("check", 13, "currentColor")}
                            Sign and Continue
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              ) : null}

              {/* ACCEPT TYPE */}
              {agreement_type === "accept" ? (
                <div id="signature_div" style={{ width: "100%" }}>
                  {/* Accept confirmation card */}
                  <div
                    style={{
                      border: this.state.is_checked === "yes" ? "1px solid #1ee0ac" : "1px solid #e5e9f2",
                      borderRadius: "8px", padding: "20px", marginBottom: "20px",
                      backgroundColor: this.state.is_checked === "yes" ? "#edfff8" : "#f8f9fc",
                      transition: "all 0.2s ease", display: "flex", alignItems: "flex-start", gap: "12px", cursor: "pointer",
                    }}
                    onClick={() => { const newVal = this.state.is_checked === "yes" ? "" : "yes"; this.setState({ is_checked: newVal }); }}
                  >
                    <div style={{ width: "22px", height: "22px", borderRadius: "4px", border: this.state.is_checked === "yes" ? `2px solid ${THEME_COLOR}` : "2px solid #c4cdd5", backgroundColor: this.state.is_checked === "yes" ? THEME_COLOR : "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: "2px", transition: "all 0.15s ease" }}>
                      {this.state.is_checked === "yes" && this.renderIcon("check", 13, "#fff")}
                    </div>
                    <div style={{ fontSize: "14px", lineHeight: "1.6", color: "#364a63" }}>
                      <strong>I accept the {this.state.agreement_title}</strong>
                      <div style={{ fontSize: "12px", color: "#8094ae", marginTop: "4px" }}>
                        By checking this box, you confirm that you have read and agree to the terms outlined above.
                      </div>
                    </div>
                  </div>

                  {/* Accept buttons */}
                  <div style={{ paddingTop: "16px", borderTop: "1px solid #e5e9f2" }}>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", justifyContent: "space-between", alignItems: "center" }}>
                      <button
                        className="btn btn-dim btn-outline-primary"
                        style={{ height: "38px", padding: "0 16px", fontSize: "13px", borderRadius: "6px", display: "inline-flex", alignItems: "center" }}
                        onClick={() => this.state.showSigneeForm ? this.close_signee() : this.open_signee()}
                        id="signee_button"
                      >
                        {this.state.showSigneeForm ? this.renderIcon("cross", 14, "currentColor", { marginRight: "4px" }) : this.renderIcon("send", 14, "currentColor", { marginRight: "4px" })}
                        {this.state.showSigneeForm ? "Close Send to Signee" : "Send to Signee"}
                      </button>
                      <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                        {this.state.button_submit_loader || this.state.loadingButton ? (
                          <button className="btn" type="button" style={{ backgroundColor: THEME_COLOR, color: THEME_TEXT_COLOR, height: "42px", padding: "0 20px", fontSize: "14px", borderRadius: "6px" }} disabled>
                            <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                            <span> Wait... </span>
                          </button>
                        ) : (
                          <button
                            className="btn btn-lg"
                            style={{ height: "42px", padding: "0 20px", fontSize: "14px", borderRadius: "6px", display: "inline-flex", alignItems: "center", opacity: this.state.is_checked === "yes" ? 1 : 0.6, cursor: this.state.is_checked === "yes" ? "pointer" : "not-allowed", transition: "all 0.2s ease", backgroundColor: THEME_COLOR, color: THEME_TEXT_COLOR, border: "none" }}
                            onClick={() => this.save()} disabled={this.isSaveDisabled()} id="save_btn"
                          >
                            {this.renderIcon("check-circle", 14, "currentColor", { marginRight: "4px" })}
                            Save
                          </button>
                        )}
                      </div>
                    </div>
                    {/* Inline Send to Signee Form */}
                    {this.state.showSigneeForm && (
                      <div style={{ marginTop: "16px", padding: "20px", border: "1px solid #e5e9f2", borderRadius: "8px", backgroundColor: "#f8f9fc" }}>
                        <h6 style={{ marginBottom: "12px" }}>Send To Signee</h6>
                        {this.state.errorMessageSignee !== "" ? (
                          <div className="example-alert" style={{ marginBottom: "10px" }}>
                            <div className="alert alert-pro alert-danger">
                              <div className="alert-text"><h4>Error</h4><p>{this.state.errorMessageSignee}</p></div>
                            </div>
                          </div>
                        ) : null}
                        {this.state.successMessageSignee !== "" ? (
                          <div className="example-alert" style={{ marginBottom: "10px" }}>
                            <div className="alert alert-pro alert-success">
                              <div className="alert-text"><h4>Success</h4><p>{this.state.successMessageSignee}</p></div>
                            </div>
                          </div>
                        ) : null}
                        <div className="alert alert-info alert-icon" style={{ marginBottom: "15px", display: "flex", alignItems: "flex-start", gap: "10px" }}>
                          {this.renderIcon("info", 16, "currentColor", { flexShrink: 0, marginTop: "1px" })}
                          <span>A secure tokenized signing link will be emailed to the signee. They can sign without logging in.</span>
                        </div>
                        <div className="row g-4">
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label style={{ fontWeight: "500", fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.5px", color: "#8094ae", display: "block", marginBottom: "6px" }}>Full Name <span style={{ color: "#e85347" }}>*</span></label>
                              <MutextField required id="signee_name" name="signee_name" type="text" placeholder="Full Name" value={this.state.signee_name} onChange={this.handleChange} variant="outlined" fullWidth autoComplete="new-password" inputProps={{ maxLength: 30 }} error={(this.state.signee_name.length > 0 && !this.isValidSigneeName(this.state.signee_name)) || this.state.signee_name.length >= 30} helperText={(this.state.signee_name.length > 0 && !this.isValidSigneeName(this.state.signee_name)) ? "Name can include only letters, spaces, apostrophes, periods, and hyphens" : (this.state.signee_name.length >= 30 ? "Maximum 30 characters allowed" : "")} />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label style={{ fontWeight: "500", fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.5px", color: "#8094ae", display: "block", marginBottom: "6px" }}>Title</label>
                              <MutextField id="signee_title" name="signee_title" type="text" placeholder="Title" value={this.state.signee_title} onChange={this.handleChange} variant="outlined" fullWidth autoComplete="new-password" inputProps={{ maxLength: 30 }} error={this.state.signee_title.length >= 30} helperText={this.state.signee_title.length >= 30 ? "Maximum 30 characters allowed" : ""} />
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="form-group">
                              <label style={{ fontWeight: "500", fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.5px", color: "#8094ae", display: "block", marginBottom: "6px" }}>Email Address <span style={{ color: "#e85347" }}>*</span></label>
                              <MutextField required id="signee_email" name="signee_email" type="text" placeholder="Email Address" value={this.state.signee_email} onChange={this.handleChange} variant="outlined" fullWidth autoComplete="new-password" error={this.getSigneeEmailError() !== ""} helperText={this.getSigneeEmailError()} />
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="form-group">
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
                                <span style={{ fontWeight: "500", fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.5px", color: "#8094ae" }}>CC (Carbon Copy)</span>
                                <span style={{ cursor: "pointer", color: this.state.ccOpen ? "#e85347" : "#364a63", fontSize: "13px", fontWeight: "500", display: "flex", alignItems: "center", gap: "4px" }} onClick={() => this.toggleCC()}>
                                  <em className={`icon ni ${this.state.ccOpen ? "ni-minus" : "ni-plus"}`} style={{ fontSize: "12px" }}></em>
                                  {this.state.ccOpen ? "Remove All" : "Add CC"}
                                </span>
                              </div>
                              {this.state.ccOpen && this.state.ccList.map((cc, index) => (
                                <div key={index} className="row g-2" style={{ marginBottom: "10px" }}>
                                  <div className="col-10">
                                    <MutextField id={`cc_email_${index}`} name={`cc_email_${index}`} type="text" label={`CC Email ${index + 1}`} value={cc} onChange={(e) => this.handleCCChange(index, e.target.value)} variant="outlined" fullWidth autoComplete="new-password" error={this.getCCEmailError(index) !== ""} helperText={this.getCCEmailError(index)} />
                                  </div>
                                  <div className="col-2" style={{ display: "flex", alignItems: "center" }}>
                                    <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => this.removeCCField(index)} title="Remove"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg></button>
                                    {index === this.state.ccList.length - 1 && (
                                      <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => this.addCCField()} title="Add Another" style={{ marginLeft: "5px" }}>{this.renderIcon("plus")}</button>
                                    )}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="form-group">
                              <textarea className="form-control" id="signee_comment" name="signee_comment" onChange={this.handleChangeTextArea} placeholder="Comments *" maxLength={1000}>{this.state.signee_comment}</textarea>
                              <div className="form-note">{this.state.signee_comment.length}/{this.state.charLimit} characters</div>
                              {this.state.characterExceededMessage && this.state.characterExceededMessage !== "" ? (
                                <div className="form-note"><code>{this.state.characterExceededMessage}</code></div>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="alert alert-warning alert-icon">
                              {this.renderIcon("alert")}{" "}
                              <strong>NOTE</strong>. This will send new agreement sign request. Your previous request will be discarded if you have sent any.
                            </div>
                          </div>
                          <div className="col-lg-12 text-right">
                            <button type="button" className="btn btn-outline-light" style={{ marginRight: "10px", height: "38px", padding: "0 16px", fontSize: "13px", borderRadius: "6px", display: "inline-flex", alignItems: "center", opacity: this.state.disabled ? 0.45 : 1 }} onClick={() => this.close_signee()} disabled={this.state.disabled}>
                              {this.renderIcon("cross", 14, "currentColor", { marginRight: "4px" })} Cancel
                            </button>
                            {this.state.disabled ? (
                              <button type="button" className="btn btn-primary" style={{ height: "38px", padding: "0 16px", fontSize: "13px", borderRadius: "6px", display: "inline-flex", alignItems: "center", opacity: 0.45, cursor: "not-allowed" }} disabled>
                                <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style={{ marginRight: "6px" }}></span> Sending...
                              </button>
                            ) : (
                              <button type="button" className="btn btn-primary" style={{ height: "38px", padding: "0 16px", fontSize: "13px", borderRadius: "6px", display: "inline-flex", alignItems: "center" }} onClick={() => this.send_to_signee()} disabled={this.isSendDisabled()}>
                                {this.renderIcon("send", 14, "currentColor", { marginRight: "4px" })} Send
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ) : null}
            </div>
          )}
        </div>
      </div>
    );
  };


  render() {
    return (
      <div className="nk-content " style={{ padding: 0 }}>
        {ReactDOM.createPortal(
          <div className="agr-toast-container">
            <NotificationToast
              message={this.state.toastMessage}
              type={this.state.toastType}
              title={this.state.toastTitle}
              onDismiss={() => this.setState({ toastMessage: "" })}
            />
          </div>,
          document.body
        )}
        <div className="container-fluid px-0 agr-page-container">
          <div className="nk-content-inner">
            <div className="nk-content-body">
              <div className="nk-block-head nk-block-head-sm" style={{ margin: 0, padding: 0 }}>
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    {this.state.agreementData.length > 0 ? (
                      <h3 className="nk-block-title page-title" style={{marginTop:10}}>Agreements</h3>
                    ) : null}
                  </div>
                  <div className="nk-block-head-content" />
                </div>
              </div>
              <div className="nk-block" style={{ marginBottom: 0 }}>
                <div className="row g-gs mx-0" style={{ marginTop: 0 }}>
                  {/* Table 5th Col Start */}
                  <div className="col-xxl-12 col-lg-12 col-md-12 col-sm-12 px-0">
                    <div className="nk-block nk-block-lg" style={{ marginBottom: 0 }}>
                      {this.state.agreementData.length > 0 ? (
                        <>
                          {/* CAROUSEL NAVIGATOR */}
                          {(() => {
                            const total = this.state.agreementData.length;
                            const idx = this.state.activeTabIndex;
                            const cur = this.state.agreementData[idx];
                            const title = cur ? cur[2] : "";
                            const isRequired = cur ? cur[3] : 0;
                            const canPrev = idx > 0;
                            const canNext = idx < total - 1;
                            return (
                              <div className="agr-carousel-nav" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid #dbdfea", padding: "8px 4px", marginBottom: "0", gap: "8px" }}>
                                <button
                                  onClick={() => { if (!canPrev) return; const a = this.state.agreementData[idx - 1]; this.show_agreement_content(a[0], a[1], a[8], a[2]); }}
                                  disabled={!canPrev}
                                  style={{ background: "none", border: "1px solid #e5e9f2", borderRadius: "50%", width: "28px", height: "28px", display: "flex", alignItems: "center", justifyContent: "center", cursor: canPrev ? "pointer" : "not-allowed", opacity: canPrev ? 1 : 0.3, flexShrink: 0, padding: 0 }}
                                >
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
                                </button>
                                <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", overflow: "hidden", gap: "4px" }}>
                                  <div style={{ display: "flex", alignItems: "center", gap: "6px", maxWidth: "100%", overflow: "hidden" }}>
                                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#364a63" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                                    <span style={{ fontWeight: "700", fontSize: "13px", color: "#364a63", borderBottom: "1.5px solid #364a63", paddingBottom: "1px", maxWidth: "240px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "inline-block" }}>{title}</span>
                                    {this.class_required(isRequired)}
                                  </div>
                                  <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                    <span style={{ fontSize: "10px", color: "#8094ae", fontWeight: "500" }}>Document {idx + 1} of {total}</span>
                                    {this.state.agreementData.map((_, di) => (
                                      <div key={di} style={{ width: di === idx ? "8px" : "5px", height: di === idx ? "8px" : "5px", borderRadius: "50%", backgroundColor: di === idx ? THEME_COLOR : "#dbdfea", transition: "all 0.15s ease", flexShrink: 0 }} />
                                    ))}
                                  </div>
                                </div>
                                <button
                                  onClick={() => { if (!canNext) return; const a = this.state.agreementData[idx + 1]; this.show_agreement_content(a[0], a[1], a[8], a[2]); }}
                                  disabled={!canNext}
                                  style={{ background: "none", border: "1px solid #e5e9f2", borderRadius: "50%", width: "28px", height: "28px", display: "flex", alignItems: "center", justifyContent: "center", cursor: canNext ? "pointer" : "not-allowed", opacity: canNext ? 1 : 0.3, flexShrink: 0, padding: 0 }}
                                >
                                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
                                </button>
                              </div>
                            );
                          })()}

                          {/* TWO COLUMN LAYOUT */}
                          <div className="row mx-0" style={{ display: "flex", alignItems: "stretch", marginTop: "14px" }}>
                            {/* LEFT: Document Panel */}
                            <div className="col-lg-8 col-xxl-7 px-0 agr-doc-col" style={{ display: "flex", flexDirection: "column" }}>
                              <div style={{ background: "#fff", border: "1px solid #e5e9f2", borderRadius: "12px", overflow: "clip", flex: 1, display: "flex", flexDirection: "column" }}>
                                <div key={this.state.agreement_accountno} className="agr-doc-fade" style={{ flex: 1, display: "flex", flexDirection: "column", padding: "0" }}>
                                  {/* DOCUMENT HEADER \u2014 chip, title, meta, actions */}
                                  <div style={{ padding: "20px 24px 16px", borderBottom: "1px solid #e5e9f2" }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "12px", flexWrap: "wrap" }}>
                                      <div style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: `${THEME_COLOR}0f`, border: `1px solid ${THEME_COLOR}30`, borderRadius: "999px", padding: "5px 12px", flexShrink: 0 }}>
                                        <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke={THEME_COLOR} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                                        <span style={{ fontSize: "10px", fontWeight: "700", color: THEME_COLOR, letterSpacing: "0.06em" }}>AGREEMENT</span>
                                      </div>
                                      <div className="agr-header-actions" style={{ display: "flex", alignItems: "center", gap: "8px", marginLeft: "auto" }}>
                                        <button
                                          className="btn btn-sm btn-dim btn-outline-light agr-fullscreen-btn"
                                          onClick={this.openReadFullscreen}
                                          title="Read in full screen"
                                          style={{ display: "flex", alignItems: "center", gap: "6px", padding: "7px 13px", borderRadius: "8px", fontSize: "12px", fontWeight: "600", flexShrink: 0 }}
                                        >
                                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 3 21 3 21 9"/><polyline points="9 21 3 21 3 15"/><line x1="21" y1="3" x2="14" y2="10"/><line x1="3" y1="21" x2="10" y2="14"/></svg>
                                          <span className="agr-btn-label">Full Screen</span>
                                        </button>
                                        <button
                                          className="btn btn-sm btn-dim btn-outline-light agr-download-btn"
                                          onClick={() => window.$("#modalDownload").modal("show")}
                                          title="Download Agreement"
                                          style={{ display: "flex", alignItems: "center", gap: "6px", padding: "7px 13px", borderRadius: "8px", fontSize: "12px", fontWeight: "600", flexShrink: 0 }}
                                        >
                                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                                          <span className="agr-btn-label">Download</span>
                                        </button>
                                        {this.state.agreement_id && (
                                          <button
                                            className="btn btn-sm btn-dim btn-outline-light agr-copy-link-btn"
                                            onClick={() => !this.state.copyLinkLoading && this.copySigneeLink()}
                                            title="Copy signee link"
                                            style={{ display: "flex", alignItems: "center", gap: "6px", padding: "7px 13px", borderRadius: "8px", fontSize: "12px", fontWeight: "600", flexShrink: 0 }}
                                          >
                                            {this.state.copyLinkLoading ? (
                                              <span className="spinner-border spinner-border-sm" style={{ width: "12px", height: "12px" }} role="status" aria-hidden="true"></span>
                                            ) : this.state.copied ? (
                                              this.renderIcon("check", 13, "currentColor")
                                            ) : (
                                              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>
                                            )}
                                            <span className="agr-btn-label">{this.state.copied ? "Copied!" : "Copy Link"}</span>
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                    <h4 style={{ fontSize: "22px", fontWeight: "700", color: "#364a63", margin: "0 0 6px 0", lineHeight: 1.3 }}>
                                      {this.state.agreement_title}
                                    </h4>
                                    {this.state.vendorData.length > 0 && this.state.resellerUserData.length > 0 && (
                                      <p style={{ fontSize: "12px", color: "#8094ae", margin: 0 }}>
                                        Between <strong style={{ color: "#526484" }}>{this.state.vendorData[0].reseller_comp}</strong> &amp;{" "}
                                        <strong style={{ color: "#526484" }}>{this.state.resellerUserData[0]["comp_name"] || this.state.resellerUserData[0]["name"]}</strong>
                                      </p>
                                    )}
                                  </div>

                                  {/* SCROLLABLE DOCUMENT CONTENT */}
                                  <div style={{ position: "relative", padding: "0 24px" }}>
                                    <div
                                      className="tab-content tab-agreement_content"
                                      style={{ maxHeight: "calc(100vh - 150px)", overflowY: "auto", marginTop: "0" }}
                                      onScroll={this.handleDocumentScroll}
                                      ref={(el) => { this.scrollContainerRef = el; }}
                                    >
                                      {/* Scroll-down helper banner — blinks briefly to attract attention.
                                          Stays rendered after reading so the layout/styling never shifts. */}
                                      {(
                                        <div className="agr-scroll-banner-blink" style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "14px", background: `${THEME_COLOR}0a`, border: `1px solid ${THEME_COLOR}26`, borderRadius: "12px", padding: "14px 16px", margin: "12px 2px 16px" }}>
                                          <div className="agr-banner-icon" style={{ width: "40px", height: "40px", borderRadius: "10px", background: THEME_COLOR, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={THEME_TEXT_COLOR} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>
                                          </div>
                                          <div style={{ minWidth: 0 }}>
                                            <div className="agr-banner-title" style={{ fontSize: "14px", fontWeight: 700, color: "#364a63", marginBottom: "2px" }}>Scroll down to read the full agreement</div>
                                            <div className="agr-banner-sub" style={{ fontSize: "12px", color: "#526484" }}>Continue becomes available after you've read to the end</div>
                                          </div>
                                        </div>
                                      )}
                                      {this.state.agreementData.map((agreementscontent, i) => (
                                        <div className={this.class_manage_content(i)} id={this.set_tabs_content(agreementscontent[6])} key={`agrcont${i}`}>
                                          {this.manage_content_with_replacable_data(agreementscontent[6], agreementscontent[1])}
                                        </div>
                                      ))}
                                    </div>
                                    {/* Floating Jump-to-bottom pill (same as fullscreen). Hidden
                                        while the reader is already at the bottom. In the normal
                                        view it also guides the user on to the "I confirm"
                                        checkbox once the document has scrolled to the end. */}
                                    {!this.state.inlineAtBottom && (
                                      <button
                                        className="btn btn-sm"
                                        onClick={() => {
                                          this.scrollAgreementToBottom(this.scrollContainerRef);
                                          // let the smooth scroll finish, then bring the consent box into view
                                          setTimeout(() => this.flashConsentAttention(), 700);
                                        }}
                                        title="Jump to bottom of agreement"
                                        style={{ position: "absolute", left: "50%", transform: "translateX(-50%)", bottom: "14px", display: "flex", alignItems: "center", gap: "6px", padding: "8px 14px", borderRadius: "999px", cursor: "pointer", background: "#fff", border: "1px solid #dbdfea", boxShadow: "0 3px 10px rgba(0,0,0,0.12)", fontSize: "12px", fontWeight: "600", color: "#526484", zIndex: 2 }}
                                      >
                                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>
                                        <span className="agr-btn-label">Jump to bottom</span>
                                      </button>
                                    )}
                                  </div>

                                  {/* READ PROGRESS BAR - slim style */}
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "10px",
                                      padding: "10px 24px",
                                      background: "#f8f9fa",
                                      borderTop: "1px solid #e5e9f2",
                                      marginTop: "0",
                                    }}
                                  >
                                    <div style={{ flex: 1, height: "3px", backgroundColor: "#dbdfea", borderRadius: "10px", overflow: "hidden" }}>
                                      <div
                                        style={{
                                          height: "100%",
                                          width: this.state.scrollProgress + "%",
                                          backgroundColor: this.state.hasReachedEndOnce ? "#1ee0ac" : THEME_COLOR,
                                          borderRadius: "10px",
                                          transition: "width 0.12s ease",
                                        }}
                                      />
                                    </div>
                                    <span style={{ fontSize: "11px", fontWeight: "600", color: "#8094ae", minWidth: "26px", textAlign: "right" }}>
                                      {this.state.scrollProgress}%
                                    </span>
                                    {this.state.hasReachedEndOnce && (
                                      <span style={{ fontSize: "11px", color: "#1ee0ac", fontWeight: "600", display: "flex", alignItems: "center", gap: "3px" }}>
                                        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                                        Fully read
                                      </span>
                                    )}
                                    <div style={{ width: "1px", height: "14px", background: "#dbdfea", margin: "0 4px", flexShrink: 0 }} />
                                    <button
                                      className="btn btn-sm"
                                      style={{ display: "flex", alignItems: "center", gap: "5px", flexShrink: 0, padding: "5px 11px", borderRadius: "6px", cursor: "pointer", background: "white", border: "1px solid #dbdfea", fontSize: "11px", fontWeight: "600", color: "#526484", transition: "all 0.13s", whiteSpace: "nowrap" }}
                                      onClick={() => window.$("#modalDownload").modal("show")}
                                      title="Export Agreement"
                                    >
                                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                                      Export
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* RIGHT: Side Panel */}
                            <div className="col-lg-4 col-xxl-5 px-0 agr-panel-col">
                              {this.renderStepPanel()}
                            </div>
                          </div>

                          {/* STICKY MOBILE CONTINUE — small screens only (CSS) */}
                          {this.state.currentStep === 1 && (
                            <div className="agr-mobile-continue">
                              <button
                                onClick={() => {
                                  if (!this.state.hasReachedEndOnce) {
                                    return;
                                  }
                                  if (!this.state.consentChecked) {
                                    this.flashConsentAttention();
                                    return;
                                  }
                                  this.goToStep(2);
                                  setTimeout(() => this.scrollToStepPanelIfNeeded(true), 200);
                                }}
                                style={{
                                  width: "100%", padding: "12px", borderRadius: "10px", border: "none",
                                  fontSize: "14px", fontWeight: "700", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
                                  background: this.state.hasReachedEndOnce && this.state.consentChecked ? THEME_COLOR : "#c4cdd5",
                                  color: this.state.hasReachedEndOnce && this.state.consentChecked ? THEME_TEXT_COLOR : "#fff",
                                  cursor: this.state.hasReachedEndOnce && this.state.consentChecked ? "pointer" : "not-allowed",
                                }}
                              >
                                Continue
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
                              </button>
                            </div>
                          )}
                        </>
                      ) : null}
                    </div>
                  </div>
                  {/* Table 5th Col End */}

                  {/* FULL-SCREEN READ OVERLAY */}
                  {this.state.readFullscreenOpen && (() => {
                    const activeRow = this.state.agreementData[this.state.activeTabIndex] || this.state.agreementData[0];
                    if (!activeRow) return null;
                    const continueLabel = this.state.agreement_type === "accept" ? "Continue to Accept" : "Continue to E-Sign";
                    const fullscreenContinueEnabled = this.state.fullscreenReadComplete;
                    // Standard portal primary button — same in the top bar and bottom bar
                    const continueBtnStyle = { display: "flex", alignItems: "center", justifyContent: "center", gap: "7px", padding: "9px 18px", borderRadius: "8px", fontSize: "13px", fontWeight: "700", border: "none", background: fullscreenContinueEnabled ? THEME_COLOR : "#c4cdd5", color: fullscreenContinueEnabled ? THEME_TEXT_COLOR : "#fff", cursor: fullscreenContinueEnabled ? "pointer" : "not-allowed", whiteSpace: "nowrap", opacity: fullscreenContinueEnabled ? 1 : 0.8 };
                    return (
                      <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 9998, backgroundColor: "#fff", display: "flex", flexDirection: "column" }}>
                        {/* TOP BAR — white portal style: Exit + title | Download + Continue */}
                        <div className="agr-fs-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 16px", background: "#fff", borderBottom: "1px solid #e5e9f2", flexShrink: 0, gap: "10px", flexWrap: "wrap" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "12px", minWidth: 0 }}>
                            <button
                              type="button"
                              className="btn btn-sm btn-dim btn-outline-light"
                              onClick={this.closeReadFullscreen}
                              title="Exit full screen"
                              style={{ display: "flex", alignItems: "center", gap: "6px", padding: "8px 14px", borderRadius: "8px", fontSize: "12px", fontWeight: "600", flexShrink: 0 }}
                            >
                              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="4 14 10 14 10 20"/><polyline points="20 10 14 10 14 4"/><line x1="14" y1="10" x2="21" y2="3"/><line x1="3" y1="21" x2="10" y2="14"/></svg>
                              Exit
                            </button>
                            <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#364a63", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", minWidth: 0 }} title={activeRow[2]}>{activeRow[2]}</h5>
                          </div>
                          <div className="agr-fs-actions" style={{ display: "flex", alignItems: "center", gap: "8px", flexShrink: 0 }}>
                            <button
                              className="btn btn-sm btn-dim btn-outline-light"
                              onClick={() => window.$("#modalDownload").modal("show")}
                              title="Download Agreement"
                              style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px", padding: "8px 14px", borderRadius: "8px", fontSize: "12px", fontWeight: "600", flexShrink: 0 }}
                            >
                              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                              Download
                            </button>
                            <button
                              onClick={this.continueEsignFromFullscreen}
                              disabled={!fullscreenContinueEnabled}
                              title="Continue to sign"
                              style={continueBtnStyle}
                            >
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                              {continueLabel}
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
                            </button>
                          </div>
                        </div>

                        {/* SCROLLABLE BODY */}
                        <div
                          className="tab-agreement_content"
                          style={{ flex: 1, overflowY: "auto", background: "#fff" }}
                          onScroll={this.handleDocumentScroll}
                          ref={(el) => { this.fullscreenScrollRef = el; }}
                        >
                          <div style={{ padding: "20px 16px 60px" }}>
                            {/* Scroll-down helper banner */}
                            {!this.state.fullscreenReadComplete && (
                              <div className="agr-scroll-banner-blink" style={{ display: "flex", alignItems: "center", gap: "16px", background: `${THEME_COLOR}0a`, border: `1px solid ${THEME_COLOR}26`, borderRadius: "12px", padding: "16px 20px", marginBottom: "24px" }}>
                                <div style={{ width: "44px", height: "44px", borderRadius: "10px", background: THEME_COLOR, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={THEME_TEXT_COLOR} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>
                                </div>
                                <div style={{ minWidth: 0 }}>
                                  <div style={{ fontSize: "15px", fontWeight: 700, color: "#364a63", marginBottom: "2px" }}>Scroll down to read the full agreement</div>
                                  <div style={{ fontSize: "13px", color: "#526484" }}>Continue becomes available after you've read to the end</div>
                                </div>
                              </div>
                            )}
                            {this.manage_content_with_replacable_data(activeRow[6], activeRow[1], "agreement_content_fs_id_")}
                          </div>
                        </div>

                        {/* Jump to bottom — hidden while already at the bottom */}
                        {!this.state.fullscreenAtBottom && (
                          <button
                            className="btn btn-sm"
                            onClick={() => this.scrollAgreementToBottom(this.fullscreenScrollRef)}
                            title="Jump to bottom of agreement"
                            style={{ position: "absolute", left: "50%", transform: "translateX(-50%)", bottom: "80px", display: "flex", alignItems: "center", gap: "6px", padding: "8px 14px", borderRadius: "999px", cursor: "pointer", background: "#fff", border: "1px solid #dbdfea", boxShadow: "0 3px 10px rgba(0,0,0,0.12)", fontSize: "12px", fontWeight: "600", color: "#526484", zIndex: 2 }}
                          >
                            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>
                            <span className="agr-btn-label">Jump to bottom</span>
                          </button>
                        )}

                        {/* BOTTOM BAR — same slim progress bar as the normal agreement view */}
                        <div className="agr-fs-bottombar" style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px 18px", background: "#f8f9fa", borderTop: "1px solid #e5e9f2", flexShrink: 0 }}>
                          <div style={{ flex: 1, height: "3px", backgroundColor: "#dbdfea", borderRadius: "10px", overflow: "hidden" }}>
                            <div
                              style={{
                                height: "100%",
                                width: this.state.scrollProgress + "%",
                                backgroundColor: this.state.hasReachedEndOnce ? "#1ee0ac" : THEME_COLOR,
                                borderRadius: "10px",
                                transition: "width 0.12s ease",
                              }}
                            />
                          </div>
                          <span style={{ fontSize: "11px", fontWeight: "600", color: "#8094ae", minWidth: "26px", textAlign: "right" }}>
                            {this.state.scrollProgress}%
                          </span>
                          {this.state.fullscreenReadComplete && (
                            <span style={{ fontSize: "11px", color: "#1ee0ac", fontWeight: "600", display: "flex", alignItems: "center", gap: "3px", whiteSpace: "nowrap" }}>
                              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                              Fully read
                            </span>
                          )}
                          <div style={{ width: "1px", height: "14px", background: "#dbdfea", margin: "0 4px", flexShrink: 0 }} />
                          <button
                            onClick={this.continueEsignFromFullscreen}
                            disabled={!fullscreenContinueEnabled}
                            title="Continue to sign"
                            style={continueBtnStyle}
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
                            {continueLabel}
                          </button>
                        </div>
                      </div>
                    );
                  })()}

                  {/* SIGNATURE ZOOM MODAL */}
                  {this.state.signatureModalOpen && (
                    <div
                      style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 9999, backgroundColor: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}
                      onClick={(e) => { if (e.target === e.currentTarget) this.setState({ signatureModalOpen: false }); }}
                    >
                      <div style={{ backgroundColor: "#fff", borderRadius: "12px", width: "100%", maxWidth: "750px", boxShadow: "0 8px 30px rgba(0,0,0,0.25)", overflow: "hidden" }}>
                        {/* Header */}
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 24px", borderBottom: "1px solid #e5e9f2" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                            <div style={{ width: "36px", height: "36px", borderRadius: "10px", backgroundColor: `${THEME_COLOR}14`, border: `1px solid ${THEME_COLOR}33`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                              {this.renderIcon("edit", 16, THEME_COLOR)}
                            </div>
                            <div>
                              <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 600, color: "#364a63" }}>Draw your signature</h5>
                              <span style={{ fontSize: "13px", color: "#8094ae" }}>Use your finger, stylus, or mouse</span>
                            </div>
                          </div>
                          <button type="button" onClick={() => this.setState({ signatureModalOpen: false })} style={{ width: "32px", height: "32px", borderRadius: "50%", border: "1px solid #dbdfea", backgroundColor: "#f5f6fa", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", color: "#526484", padding: 0 }}>
                            {this.renderIcon("cross", 14)}
                          </button>
                        </div>
                        {/* Canvas Area */}
                        <div style={{ padding: "20px 24px" }}>
                          <div style={{ border: "1px solid #e5e9f2", borderRadius: "8px", height: "300px", position: "relative", backgroundColor: "#fafbfc" }}>
                            <SignatureCanvas
                              clearOnResize={false}
                              penColor={this.state.signatureColor}
                              minWidth={this.state.penWidth}
                              maxWidth={this.state.penWidth + 0.5}
                              canvasProps={{ 
                                style: { width: "100%", height: "100%", display: "block" }
                              }}
                              velocityFilterWeight={0.7}
                              throttle={50}
                              ref={(ref) => { 
                                this.signaturePadModal = ref; 
                                if (ref) {
                                  setTimeout(() => this.resizeSignatureCanvas(ref, 300), 0);
                                }
                              }}
                              onBegin={this.handleModalSignatureBegin}
                              onEnd={this.handleModalSignatureEnd}
                            />
                            {/* Placeholder - shown only when canvas is empty */}
                            {this.state.modalCanvasEmpty && (
                              <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: "50px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", pointerEvents: "none" }}>
                                <div style={{ width: "56px", height: "56px", borderRadius: "50%", backgroundColor: "#e4e7eb", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "12px" }}>
                                  {this.renderIcon("edit", 22, "#8094ae")}
                                </div>
                                <div style={{ fontSize: "15px", fontWeight: 500, color: "#526484" }}>Draw your signature here</div>
                                <div style={{ fontSize: "13px", color: "#8094ae", marginTop: "4px" }}>Use finger on mobile &bull; Mouse on desktop</div>
                              </div>
                            )}
                            {/* Baseline guide */}
                            <div style={{ position: "absolute", bottom: "50px", left: "8%", right: "8%", height: "1px", backgroundColor: "#dbdfea", pointerEvents: "none" }} />
                          </div>
                          {/* Color Picker + Undo/Clear */}
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "14px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              {/* Pen sizes */}
                              {this.penSizes.map((s, idx) => (
                                <button
                                  key={idx}
                                  type="button"
                                  title={s.label}
                                  onClick={() => this.setState({ penWidth: s.penWidth })}
                                  style={{
                                    width: "28px", height: "28px", borderRadius: "50%",
                                    background: this.state.penWidth === s.penWidth ? "rgba(15,58,112,0.08)" : "#fff",
                                    border: this.state.penWidth === s.penWidth ? "1.5px solid #0F3A70" : "1.5px solid #e5e9f2",
                                    cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
                                    padding: 0, transition: "all 0.13s",
                                  }}
                                >
                                  <div style={{ width: (s.dotSize + 1) + "px", height: (s.dotSize + 1) + "px", borderRadius: "50%", background: "#526484" }} />
                                </button>
                              ))}
                              {/* Divider */}
                              <div style={{ width: "1px", height: "18px", backgroundColor: "#e5e9f2" }} />
                              {/* Ink colors */}
                              {this.inkColors.map((c, idx) => (
                                <div
                                  key={idx}
                                  onClick={() => this.setState({ signatureColor: c.value })}
                                  title={c.name}
                                  style={{
                                    width: "20px", height: "20px", borderRadius: "50%",
                                    backgroundColor: c.value, cursor: "pointer",
                                    border: this.state.signatureColor === c.value ? "2px solid #526484" : "2px solid transparent",
                                    boxShadow: this.state.signatureColor === c.value ? "0 0 0 2px white" : "none",
                                    transition: "all 0.13s",
                                  }}
                                />
                              ))}
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                              <button
                                type="button"
                                style={{ background: "none", border: "none", color: "#e85347", cursor: "pointer", fontSize: "13px", fontWeight: "500", display: "flex", alignItems: "center", gap: "4px" }}
                                onClick={this.undoModalSignature}
                              >
                                {this.renderIcon("undo", 14)} Undo
                              </button>
                              <button
                                type="button"
                                style={{ background: "none", border: "none", color: "#e85347", cursor: "pointer", fontSize: "13px", fontWeight: "500", display: "flex", alignItems: "center", gap: "4px" }}
                                onClick={this.clearModalSignature}
                              >
                                Clear all
                              </button>
                            </div>
                          </div>
                        </div>
                        {/* Footer */}
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 24px", borderTop: "1px solid #e5e9f2", backgroundColor: "#fafbfc" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "6px", color: "#8094ae", fontSize: "12px" }}>
                            {this.renderIcon("lock", 14)}
                            <span>Legally binding &bull; 256-bit encrypted</span>
                          </div>
                          <div style={{ display: "flex", gap: "8px" }}>
                            <button className="btn btn-outline-light" onClick={() => this.setState({ signatureModalOpen: false })} style={{ borderRadius: "6px", padding: "8px 20px" }}>Cancel</button>
                            <button className="btn" style={{ backgroundColor: THEME_COLOR, color: THEME_TEXT_COLOR, borderRadius: "6px", padding: "8px 20px", opacity: this.state.modalCanvasEmpty ? 0.45 : 1, cursor: this.state.modalCanvasEmpty ? "not-allowed" : "pointer" }} onClick={this.useModalSignature} disabled={this.state.modalCanvasEmpty}>
                              {this.renderIcon("check", 14, "currentColor", { marginRight: "4px" })}
                              Use this signature
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                </div>
              </div>
              {/* SUCCESS MODAL START */}
              <div className="modal fade" tabIndex="-1" id="modalAlert">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      onClick={() => {
                        this.modalHide();
                      }}
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-check bg-success"></em>
                        <h4 className="nk-modal-title">
                          {this.state.successMessage}
                        </h4>
                        <div className="nk-modal-text">
                          <div className="caption-text">
                            You've successfully signed{" "}
                            <strong>Agreement</strong>
                          </div>
                        </div>
                        <div className="nk-modal-action">
                          <a
                            href="#"
                            className="btn btn-lg btn-mw btn-primary"
                            onClick={() => {
                              this.modalHide();
                            }}
                          >
                            OK
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* SUCCESS MODAL End */}
              {/* ERROR MODAL START */}
              <div className="modal fade" tabIndex="-1" id="modalAlertError">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></em>
                        <h4 className="nk-modal-title">Unable to Upload!</h4>
                        <div className="nk-modal-text">
                          <p className="lead">{this.state.errorMessage}</p>
                        </div>
                        <div className="nk-modal-action mt-5">
                          <a
                            href="#"
                            className="btn btn-lg btn-mw btn-light"
                            data-dismiss="modal"
                          >
                            Cancel
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* ERROR MODAL END */}
              {/* DOWNLOAD MODAL START */}
              <div className="modal fade" tabIndex="-1" id="modalDownload" data-backdrop={this.state.downloading ? "static" : true} data-keyboard={!this.state.downloading}>
                <div className="modal-dialog modal-dialog-centered" role="document">
                  <div className="modal-content" style={{ borderRadius: "16px", border: "none", overflow: "hidden", position: "relative" }}>
                    {/* Downloading Overlay */}
                    {this.state.downloading && (
                      <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(255,255,255,0.92)", zIndex: 10, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", borderRadius: "16px" }}>
                        <div style={{ width: "48px", height: "48px", border: "4px solid #e5e9f2", borderTopColor: THEME_COLOR, borderRadius: "50%", animation: "spin 0.8s linear infinite", marginBottom: "16px" }} />
                        <h6 style={{ fontWeight: 600, fontSize: "15px", color: "#364a63", marginBottom: "4px" }}>Preparing your {this.state.downloadingFormat} file...</h6>
                        <p style={{ color: "#8094ae", fontSize: "13px", margin: 0 }}>This may take a moment</p>
                      </div>
                    )}
                    <style>{`@keyframes spin { to { transform: rotate(360deg); } }
                      @media (max-width: 575.98px) {
                        .signature-action-footer {
                          align-items: stretch !important;
                        }
                        .signature-action-legal {
                          width: 100%;
                          justify-content: center;
                          text-align: center;
                        }
                        .signature-action-buttons {
                          width: 100% !important;
                          display: flex !important;
                          flex-wrap: nowrap !important;
                          gap: 8px !important;
                        }
                        .signature-action-btn {
                          flex: 1 1 0;
                          min-width: 0;
                          justify-content: center;
                        }
                      }`}</style>
                    <div className="modal-body" style={{ padding: "32px" }}>
                      {/* Download Header */}
                      <div style={{ display: "flex", alignItems: "center", gap: "14px", marginBottom: "16px" }}>
                        <div style={{ width: "48px", height: "48px", borderRadius: "12px", backgroundColor: "#f5f6fa", display: "flex", alignItems: "center", justifyContent: "center" }}>
                          {this.renderIcon("download", 22, "#526484")}
                        </div>
                        <div>
                          <h5 style={{ fontWeight: 700, fontSize: "20px", margin: "0 0 4px 0", color: "#364a63" }}>Download Agreement</h5>
                          <p style={{ color: "#8094ae", fontSize: "14px", margin: 0 }}>{this.state.agreement_title}</p>
                        </div>
                      </div>
                      <p style={{ color: "#526484", fontSize: "14px", lineHeight: "1.6", marginBottom: "24px" }}>Choose a format to download this agreement.</p>
                      {/* PDF Option */}
                      <div
                        onClick={() => { if (!this.state.downloading) this.downloadPdf(); }}
                        onMouseOver={(e) => { if (!this.state.downloading) { e.currentTarget.style.borderColor = THEME_COLOR; e.currentTarget.style.background = `${THEME_COLOR}0a`; } }}
                        onMouseOut={(e) => { e.currentTarget.style.borderColor = '#e5e9f2'; e.currentTarget.style.background = 'white'; }}
                        style={{ display: "flex", alignItems: "center", padding: "12px 14px", border: "1.5px solid #e5e9f2", borderRadius: "9px", cursor: this.state.downloading ? "not-allowed" : "pointer", marginBottom: "8px", opacity: this.state.downloading ? 0.5 : 1, background: "white", transition: "all 0.13s" }}
                      >
                        <div style={{ width: "36px", height: "36px", borderRadius: "8px", backgroundColor: "#FEE2E2", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "12px", flexShrink: 0 }}>
                          {this.renderIcon("file-pdf", 16, "#DC2626")}
                        </div>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: 600, fontSize: "13px", color: "#364a63" }}>PDF Document</div>
                          <div style={{ fontSize: "11px", color: "#8094ae", marginTop: "1px" }}>Best for printing</div>
                        </div>
                        {this.renderIcon("download", 12, "#8094ae", { marginLeft: "auto", flexShrink: 0 })}
                      </div>
                      {/* DOCX Option */}
                      <div
                        onClick={() => { if (!this.state.downloading) this.handleDownload(); }}
                        onMouseOver={(e) => { if (!this.state.downloading) { e.currentTarget.style.borderColor = THEME_COLOR; e.currentTarget.style.background = `${THEME_COLOR}0a`; } }}
                        onMouseOut={(e) => { e.currentTarget.style.borderColor = '#e5e9f2'; e.currentTarget.style.background = 'white'; }}
                        style={{ display: "flex", alignItems: "center", padding: "12px 14px", border: "1.5px solid #e5e9f2", borderRadius: "9px", cursor: this.state.downloading ? "not-allowed" : "pointer", marginBottom: "8px", opacity: this.state.downloading ? 0.5 : 1, background: "white", transition: "all 0.13s" }}
                      >
                        <div style={{ width: "36px", height: "36px", borderRadius: "8px", backgroundColor: "#DBEAFE", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "12px", flexShrink: 0 }}>
                          {this.renderIcon("file-doc", 16, "#2563EB")}
                        </div>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: 600, fontSize: "13px", color: "#364a63" }}>Word Document (.docx)</div>
                          <div style={{ fontSize: "11px", color: "#8094ae", marginTop: "1px" }}>Best for Track Changes redlining</div>
                        </div>
                        {this.renderIcon("download", 12, "#8094ae", { marginLeft: "auto", flexShrink: 0 })}
                      </div>
                      {/* TXT Option */}
                      <div
                        onClick={() => { if (!this.state.downloading) this.downloadTxt(); }}
                        onMouseOver={(e) => { if (!this.state.downloading) { e.currentTarget.style.borderColor = THEME_COLOR; e.currentTarget.style.background = `${THEME_COLOR}0a`; } }}
                        onMouseOut={(e) => { e.currentTarget.style.borderColor = '#e5e9f2'; e.currentTarget.style.background = 'white'; }}
                        style={{ display: "flex", alignItems: "center", padding: "12px 14px", border: "1.5px solid #e5e9f2", borderRadius: "9px", cursor: this.state.downloading ? "not-allowed" : "pointer", marginBottom: "8px", opacity: this.state.downloading ? 0.5 : 1, background: "white", transition: "all 0.13s" }}
                      >
                        <div style={{ width: "36px", height: "36px", borderRadius: "8px", backgroundColor: "#F3F4F6", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "12px", flexShrink: 0 }}>
                          {this.renderIcon("file-text", 16, "#526484")}
                        </div>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontWeight: 600, fontSize: "13px", color: "#364a63" }}>Plain Text (.txt)</div>
                          <div style={{ fontSize: "11px", color: "#8094ae", marginTop: "1px" }}>Lightweight copy for quick reference</div>
                        </div>
                        {this.renderIcon("download", 12, "#8094ae", { marginLeft: "auto", flexShrink: 0 })}
                      </div>
                      {/* Cancel */}
                      <div style={{ textAlign: "right" }}>
                        <button className="btn btn-outline-light" data-dismiss="modal" style={{ height: "38px", padding: "0 20px", fontSize: "13px", borderRadius: "6px", display: "inline-flex", alignItems: "center" }}>
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* DOWNLOAD MODAL END */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
